//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.0.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IPlaceClient {
    /**
     * @param cityCode (optional) 
     * @return Success
     */
    getAirQuality(cityCode: number | undefined): Promise<AQIStationDetailListBaseResponse>;
    /**
     * @param cityCode (optional) 
     * @return Success
     */
    getCategoryTree(cityCode: number | undefined): Promise<CategoryListBaseResponse>;
    /**
     * @param cityCode (optional) 
     * @return Success
     */
    getCategoryGroups(cityCode: number | undefined): Promise<CategoryListBaseResponse>;
    /**
     * @param categoryGroupId (optional) 
     * @return Success
     */
    getCategories(categoryGroupId: string | undefined): Promise<CategoryListBaseResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addCategoryGroup(body: CategoryGroupAddRequest | undefined): Promise<CategoryBaseResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addCategory(body: CategoryAddRequest | undefined): Promise<CategoryBaseResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateCategory(body: CategoryUpdateRequest | undefined): Promise<CategoryBaseResponse>;
    /**
     * @param categoryId (optional) 
     * @return Success
     */
    getTranslationsOfCategory(categoryId: string | undefined): Promise<TranslationListBaseResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addCategoryTranslation(body: TranslationRequest | undefined): Promise<TranslationBaseResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateCategoryTranslation(body: TranslationRequest | undefined): Promise<void>;
    /**
     * @param categoryId (optional) 
     * @return Success
     */
    deleteCategory(categoryId: string | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addCategoryExtraField(body: ExtraFieldAddRequest | undefined): Promise<CategoryExtraFieldBaseResponse>;
    /**
     * @param categoryId (optional) 
     * @return Success
     */
    listCategoryExtraFields(categoryId: string | undefined): Promise<CategoryExtraField[]>;
    /**
     * @param categoryId (optional) 
     * @param extraFieldId (optional) 
     * @return Success
     */
    deleteCategoryExtraField(categoryId: string | undefined, extraFieldId: string | undefined): Promise<boolean>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateCategoryExtraField(body: ExtraFieldUpdateRequest | undefined): Promise<CategoryExtraField>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addCity(body: City | undefined): Promise<CityBaseResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addCounty(body: CountyAddRequest | undefined): Promise<CountyBaseResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addNeighborhood(body: NeighborhoodAddRequest | undefined): Promise<NeighborhoodBaseResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    searchNeighborhoods(body: NeighborhoodSearchCriteriaPageableSearch | undefined): Promise<NeighborhoodPageableResponse>;
    /**
     * @param countyCode (optional) 
     * @return Success
     */
    deleteCounty(countyCode: number | undefined): Promise<void>;
    /**
     * @param cityCode (optional) 
     * @return Success
     */
    deleteCity(cityCode: number | undefined): Promise<void>;
    /**
     * @return Success
     */
    getAllCities(): Promise<CityListBaseResponse>;
    /**
     * @param cityCode (optional) 
     * @return Success
     */
    getCityByCode(cityCode: number | undefined): Promise<CityBaseResponse>;
    /**
     * @param cityCode (optional) 
     * @return Success
     */
    getCountiesByCity(cityCode: number | undefined): Promise<CountyListBaseResponse>;
    /**
     * @return Success
     */
    getFlights(): Promise<Flight[]>;
    /**
     * @return Success
     */
    getIncidentTypes(): Promise<IncidentTypeDtoListBaseResponse>;
    /**
     * @param name (optional) 
     * @param iconFile (optional) 
     * @return Success
     */
    addIncidentType(name: string | undefined, iconFile: FileParameter | undefined): Promise<IncidentTypeDtoBaseResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addIncidentTypeTranslation(body: TranslationRequest | undefined): Promise<TranslationBaseResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateIncidentTypeTranslation(body: TranslationRequest | undefined): Promise<TranslationBaseResponse>;
    /**
     * @param incidentTypeId (optional) 
     * @param iconFile (optional) 
     * @return Success
     */
    updateIncidentTypeIcon(incidentTypeId: string | undefined, iconFile: FileParameter | undefined): Promise<IncidentTypeDtoBaseResponse>;
    /**
     * @param incidentTypeId (optional) 
     * @return Success
     */
    deleteIncidentType(incidentTypeId: string | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addIncident(body: IncidentAddRequest | undefined): Promise<IncidentBaseResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addIncidentTranslation(body: TranslationRequest | undefined): Promise<TranslationBaseResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateIncidentTranslation(body: TranslationRequest | undefined): Promise<TranslationBaseResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    searchIncidents(body: IncidentSearchCriteriaPageableSearch | undefined): Promise<IncidentDtoPageableResponse>;
    /**
     * @param incidentId (optional) 
     * @return Success
     */
    deleteIncident(incidentId: string | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateIncident(body: IncidentUpdateRequest | undefined): Promise<Incident>;
    /**
     * @return Success
     */
    getIssueCategories(): Promise<IssueCategoryDtoListBaseResponse>;
    /**
     * @param name (optional) 
     * @return Success
     */
    addIssueCategory(name: string | undefined): Promise<IssueCategoryDtoBaseResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addIssueCategoryTranslation(body: TranslationRequest | undefined): Promise<TranslationBaseResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateIssueCategoryTranslation(body: TranslationRequest | undefined): Promise<TranslationBaseResponse>;
    /**
     * @param issueCategoryId (optional) 
     * @return Success
     */
    deleteIssueCategory(issueCategoryId: string | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    searchIssues(body: IssueSearchCriteriaPageableSearch | undefined): Promise<IssuePageableResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addIssue(body: IssueAddRequest | undefined): Promise<Issue>;
    /**
     * @param issueId (optional) 
     * @param files (optional) 
     * @return Success
     */
    uploadIssueFiles(issueId: string | undefined, files: FileParameter | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    operatorProcessOnIssue(body: IssueUpdateRequest | undefined): Promise<Issue>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addMayor(body: MayorAddRequest | undefined): Promise<Mayor>;
    /**
     * @param cityCode (optional) 
     * @return Success
     */
    getMayor(cityCode: number | undefined): Promise<Mayor>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateMayor(body: MayorUpdateRequest | undefined): Promise<Mayor>;
    /**
     * @param mayorId (optional) 
     * @return Success
     */
    deleteMayor(mayorId: string | undefined): Promise<void>;
    /**
     * @param cityCode (optional) 
     * @param file (optional) 
     * @return Success
     */
    uploadMayorPhoto(cityCode: number | undefined, file: FileParameter | undefined): Promise<boolean>;
    /**
     * @param cityCode (optional) 
     * @return Success
     */
    deleteMayorPhoto(cityCode: number | undefined): Promise<boolean>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addNews(body: NewsAddRequest | undefined): Promise<News>;
    /**
     * @param body (optional) 
     * @return Success
     */
    searchNews(body: NewsSearchCriteriaPageableSearch | undefined): Promise<NewsDTOPageableResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateNews(body: NewsUpdateRequest | undefined): Promise<NewsBaseResponse>;
    /**
     * @param newsId (optional) 
     * @return Success
     */
    deleteNews(newsId: string | undefined): Promise<void>;
    /**
     * @param newsId (optional) 
     * @return Success
     */
    archiveNews(newsId: string | undefined): Promise<void>;
    /**
     * @param newsId (optional) 
     * @return Success
     */
    unarchiveNews(newsId: string | undefined): Promise<void>;
    /**
     * @param newsId (optional) 
     * @param file (optional) 
     * @return Success
     */
    uploadNewsAsset(newsId: string | undefined, file: FileParameter | undefined): Promise<boolean>;
    /**
     * @param newsId (optional) 
     * @param newsAssetId (optional) 
     * @return Success
     */
    deleteNewsAsset(newsId: string | undefined, newsAssetId: string | undefined): Promise<boolean>;
    /**
     * @param cityCode (optional) 
     * @param title (optional) 
     * @param content (optional) 
     * @return Success
     */
    sendBroadCastMessage(cityCode: number | undefined, title: string | undefined, content: string | undefined): Promise<void>;
    /**
     * @param cityCode (optional) 
     * @param playerId (optional) 
     * @param title (optional) 
     * @param content (optional) 
     * @return Success
     */
    sendSpesificMessage(cityCode: number | undefined, playerId: string | undefined, title: string | undefined, content: string | undefined): Promise<void>;
    /**
     * @param cityCode (optional) 
     * @param playerId (optional) 
     * @return Success
     */
    getNotifications(cityCode: number | undefined, playerId: string | undefined): Promise<NotificationDto[]>;
    /**
     * @param cityCode (optional) 
     * @return Success
     */
    getPharmaciesOnDuty(cityCode: number | undefined): Promise<PharmacyListBaseResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    searchPlaces(body: PlaceSearchCriteriaPageableSearch | undefined): Promise<PlacePageableResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addPlace(body: PlaceAddRequest | undefined): Promise<PlaceBaseResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updatePlace(body: PlaceUpdateRequest | undefined): Promise<PlaceBaseResponse>;
    /**
     * @param placeId (optional) 
     * @return Success
     */
    deletePlace(placeId: string | undefined): Promise<void>;
    /**
     * @param placeId (optional) 
     * @param file (optional) 
     * @return Success
     */
    uploadPlaceAsset(placeId: string | undefined, file: FileParameter | undefined): Promise<boolean>;
    /**
     * @param placeId (optional) 
     * @param placeAssetId (optional) 
     * @return Success
     */
    deletePlaceAsset(placeId: string | undefined, placeAssetId: string | undefined): Promise<boolean>;
    /**
     * @param name (optional) 
     * @return Success
     */
    poiSearch(name: string | undefined): Promise<Place[]>;
    /**
     * @return Success
     */
    getRealms(): Promise<RealmDtoListBaseResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addRoute(body: RouteAddRequest | undefined): Promise<RouteBaseResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getRoutes(body: string[] | undefined): Promise<RouteListBaseResponse>;
}

export class PlaceClient implements IPlaceClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param cityCode (optional) 
     * @return Success
     */
    getAirQuality(cityCode: number | undefined , cancelToken?: CancelToken | undefined): Promise<AQIStationDetailListBaseResponse> {
        let url_ = this.baseUrl + "/AQI/GetAirQuality?";
        if (cityCode === null)
            throw new Error("The parameter 'cityCode' cannot be null.");
        else if (cityCode !== undefined)
            url_ += "cityCode=" + encodeURIComponent("" + cityCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAirQuality(_response);
        });
    }

    protected processGetAirQuality(response: AxiosResponse): Promise<AQIStationDetailListBaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AQIStationDetailListBaseResponse.fromJS(resultData200);
            return Promise.resolve<AQIStationDetailListBaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AQIStationDetailListBaseResponse>(null as any);
    }

    /**
     * @param cityCode (optional) 
     * @return Success
     */
    getCategoryTree(cityCode: number | undefined , cancelToken?: CancelToken | undefined): Promise<CategoryListBaseResponse> {
        let url_ = this.baseUrl + "/Category/GetCategoryTree?";
        if (cityCode === null)
            throw new Error("The parameter 'cityCode' cannot be null.");
        else if (cityCode !== undefined)
            url_ += "cityCode=" + encodeURIComponent("" + cityCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCategoryTree(_response);
        });
    }

    protected processGetCategoryTree(response: AxiosResponse): Promise<CategoryListBaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CategoryListBaseResponse.fromJS(resultData200);
            return Promise.resolve<CategoryListBaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryListBaseResponse>(null as any);
    }

    /**
     * @param cityCode (optional) 
     * @return Success
     */
    getCategoryGroups(cityCode: number | undefined , cancelToken?: CancelToken | undefined): Promise<CategoryListBaseResponse> {
        let url_ = this.baseUrl + "/Category/GetCategoryGroups?";
        if (cityCode === null)
            throw new Error("The parameter 'cityCode' cannot be null.");
        else if (cityCode !== undefined)
            url_ += "cityCode=" + encodeURIComponent("" + cityCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCategoryGroups(_response);
        });
    }

    protected processGetCategoryGroups(response: AxiosResponse): Promise<CategoryListBaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CategoryListBaseResponse.fromJS(resultData200);
            return Promise.resolve<CategoryListBaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryListBaseResponse>(null as any);
    }

    /**
     * @param categoryGroupId (optional) 
     * @return Success
     */
    getCategories(categoryGroupId: string | undefined , cancelToken?: CancelToken | undefined): Promise<CategoryListBaseResponse> {
        let url_ = this.baseUrl + "/Category/GetCategories?";
        if (categoryGroupId === null)
            throw new Error("The parameter 'categoryGroupId' cannot be null.");
        else if (categoryGroupId !== undefined)
            url_ += "categoryGroupId=" + encodeURIComponent("" + categoryGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCategories(_response);
        });
    }

    protected processGetCategories(response: AxiosResponse): Promise<CategoryListBaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CategoryListBaseResponse.fromJS(resultData200);
            return Promise.resolve<CategoryListBaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryListBaseResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addCategoryGroup(body: CategoryGroupAddRequest | undefined , cancelToken?: CancelToken | undefined): Promise<CategoryBaseResponse> {
        let url_ = this.baseUrl + "/Category/AddCategoryGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddCategoryGroup(_response);
        });
    }

    protected processAddCategoryGroup(response: AxiosResponse): Promise<CategoryBaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CategoryBaseResponse.fromJS(resultData200);
            return Promise.resolve<CategoryBaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryBaseResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addCategory(body: CategoryAddRequest | undefined , cancelToken?: CancelToken | undefined): Promise<CategoryBaseResponse> {
        let url_ = this.baseUrl + "/Category/AddCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddCategory(_response);
        });
    }

    protected processAddCategory(response: AxiosResponse): Promise<CategoryBaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CategoryBaseResponse.fromJS(resultData200);
            return Promise.resolve<CategoryBaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryBaseResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCategory(body: CategoryUpdateRequest | undefined , cancelToken?: CancelToken | undefined): Promise<CategoryBaseResponse> {
        let url_ = this.baseUrl + "/Category/UpdateCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCategory(_response);
        });
    }

    protected processUpdateCategory(response: AxiosResponse): Promise<CategoryBaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CategoryBaseResponse.fromJS(resultData200);
            return Promise.resolve<CategoryBaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryBaseResponse>(null as any);
    }

    /**
     * @param categoryId (optional) 
     * @return Success
     */
    getTranslationsOfCategory(categoryId: string | undefined , cancelToken?: CancelToken | undefined): Promise<TranslationListBaseResponse> {
        let url_ = this.baseUrl + "/Category/GetTranslationsOfCategory?";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTranslationsOfCategory(_response);
        });
    }

    protected processGetTranslationsOfCategory(response: AxiosResponse): Promise<TranslationListBaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TranslationListBaseResponse.fromJS(resultData200);
            return Promise.resolve<TranslationListBaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TranslationListBaseResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addCategoryTranslation(body: TranslationRequest | undefined , cancelToken?: CancelToken | undefined): Promise<TranslationBaseResponse> {
        let url_ = this.baseUrl + "/Category/AddCategoryTranslation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddCategoryTranslation(_response);
        });
    }

    protected processAddCategoryTranslation(response: AxiosResponse): Promise<TranslationBaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TranslationBaseResponse.fromJS(resultData200);
            return Promise.resolve<TranslationBaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TranslationBaseResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCategoryTranslation(body: TranslationRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Category/UpdateCategoryTranslation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCategoryTranslation(_response);
        });
    }

    protected processUpdateCategoryTranslation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param categoryId (optional) 
     * @return Success
     */
    deleteCategory(categoryId: string | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Category/DeleteCategory?";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCategory(_response);
        });
    }

    protected processDeleteCategory(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addCategoryExtraField(body: ExtraFieldAddRequest | undefined , cancelToken?: CancelToken | undefined): Promise<CategoryExtraFieldBaseResponse> {
        let url_ = this.baseUrl + "/Category/AddCategoryExtraField";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddCategoryExtraField(_response);
        });
    }

    protected processAddCategoryExtraField(response: AxiosResponse): Promise<CategoryExtraFieldBaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CategoryExtraFieldBaseResponse.fromJS(resultData200);
            return Promise.resolve<CategoryExtraFieldBaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryExtraFieldBaseResponse>(null as any);
    }

    /**
     * @param categoryId (optional) 
     * @return Success
     */
    listCategoryExtraFields(categoryId: string | undefined , cancelToken?: CancelToken | undefined): Promise<CategoryExtraField[]> {
        let url_ = this.baseUrl + "/Category/ListCategoryExtraFields?";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListCategoryExtraFields(_response);
        });
    }

    protected processListCategoryExtraFields(response: AxiosResponse): Promise<CategoryExtraField[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CategoryExtraField.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CategoryExtraField[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryExtraField[]>(null as any);
    }

    /**
     * @param categoryId (optional) 
     * @param extraFieldId (optional) 
     * @return Success
     */
    deleteCategoryExtraField(categoryId: string | undefined, extraFieldId: string | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/Category/DeleteCategoryExtraField?";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (extraFieldId === null)
            throw new Error("The parameter 'extraFieldId' cannot be null.");
        else if (extraFieldId !== undefined)
            url_ += "extraFieldId=" + encodeURIComponent("" + extraFieldId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCategoryExtraField(_response);
        });
    }

    protected processDeleteCategoryExtraField(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCategoryExtraField(body: ExtraFieldUpdateRequest | undefined , cancelToken?: CancelToken | undefined): Promise<CategoryExtraField> {
        let url_ = this.baseUrl + "/Category/UpdateCategoryExtraField";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCategoryExtraField(_response);
        });
    }

    protected processUpdateCategoryExtraField(response: AxiosResponse): Promise<CategoryExtraField> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CategoryExtraField.fromJS(resultData200);
            return Promise.resolve<CategoryExtraField>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryExtraField>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addCity(body: City | undefined , cancelToken?: CancelToken | undefined): Promise<CityBaseResponse> {
        let url_ = this.baseUrl + "/City/AddCity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddCity(_response);
        });
    }

    protected processAddCity(response: AxiosResponse): Promise<CityBaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CityBaseResponse.fromJS(resultData200);
            return Promise.resolve<CityBaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CityBaseResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addCounty(body: CountyAddRequest | undefined , cancelToken?: CancelToken | undefined): Promise<CountyBaseResponse> {
        let url_ = this.baseUrl + "/City/AddCounty";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddCounty(_response);
        });
    }

    protected processAddCounty(response: AxiosResponse): Promise<CountyBaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CountyBaseResponse.fromJS(resultData200);
            return Promise.resolve<CountyBaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountyBaseResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNeighborhood(body: NeighborhoodAddRequest | undefined , cancelToken?: CancelToken | undefined): Promise<NeighborhoodBaseResponse> {
        let url_ = this.baseUrl + "/City/AddNeighborhood";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddNeighborhood(_response);
        });
    }

    protected processAddNeighborhood(response: AxiosResponse): Promise<NeighborhoodBaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NeighborhoodBaseResponse.fromJS(resultData200);
            return Promise.resolve<NeighborhoodBaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NeighborhoodBaseResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchNeighborhoods(body: NeighborhoodSearchCriteriaPageableSearch | undefined , cancelToken?: CancelToken | undefined): Promise<NeighborhoodPageableResponse> {
        let url_ = this.baseUrl + "/City/SearchNeighborhoods";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchNeighborhoods(_response);
        });
    }

    protected processSearchNeighborhoods(response: AxiosResponse): Promise<NeighborhoodPageableResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NeighborhoodPageableResponse.fromJS(resultData200);
            return Promise.resolve<NeighborhoodPageableResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NeighborhoodPageableResponse>(null as any);
    }

    /**
     * @param countyCode (optional) 
     * @return Success
     */
    deleteCounty(countyCode: number | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/City/DeleteCounty?";
        if (countyCode === null)
            throw new Error("The parameter 'countyCode' cannot be null.");
        else if (countyCode !== undefined)
            url_ += "countyCode=" + encodeURIComponent("" + countyCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCounty(_response);
        });
    }

    protected processDeleteCounty(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param cityCode (optional) 
     * @return Success
     */
    deleteCity(cityCode: number | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/City/DeleteCity?";
        if (cityCode === null)
            throw new Error("The parameter 'cityCode' cannot be null.");
        else if (cityCode !== undefined)
            url_ += "cityCode=" + encodeURIComponent("" + cityCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCity(_response);
        });
    }

    protected processDeleteCity(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getAllCities(  cancelToken?: CancelToken | undefined): Promise<CityListBaseResponse> {
        let url_ = this.baseUrl + "/City/GetAllCities";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllCities(_response);
        });
    }

    protected processGetAllCities(response: AxiosResponse): Promise<CityListBaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CityListBaseResponse.fromJS(resultData200);
            return Promise.resolve<CityListBaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CityListBaseResponse>(null as any);
    }

    /**
     * @param cityCode (optional) 
     * @return Success
     */
    getCityByCode(cityCode: number | undefined , cancelToken?: CancelToken | undefined): Promise<CityBaseResponse> {
        let url_ = this.baseUrl + "/City/GetCityByCode?";
        if (cityCode === null)
            throw new Error("The parameter 'cityCode' cannot be null.");
        else if (cityCode !== undefined)
            url_ += "cityCode=" + encodeURIComponent("" + cityCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCityByCode(_response);
        });
    }

    protected processGetCityByCode(response: AxiosResponse): Promise<CityBaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CityBaseResponse.fromJS(resultData200);
            return Promise.resolve<CityBaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CityBaseResponse>(null as any);
    }

    /**
     * @param cityCode (optional) 
     * @return Success
     */
    getCountiesByCity(cityCode: number | undefined , cancelToken?: CancelToken | undefined): Promise<CountyListBaseResponse> {
        let url_ = this.baseUrl + "/City/GetCountiesByCity?";
        if (cityCode === null)
            throw new Error("The parameter 'cityCode' cannot be null.");
        else if (cityCode !== undefined)
            url_ += "cityCode=" + encodeURIComponent("" + cityCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCountiesByCity(_response);
        });
    }

    protected processGetCountiesByCity(response: AxiosResponse): Promise<CountyListBaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CountyListBaseResponse.fromJS(resultData200);
            return Promise.resolve<CountyListBaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountyListBaseResponse>(null as any);
    }

    /**
     * @return Success
     */
    getFlights(  cancelToken?: CancelToken | undefined): Promise<Flight[]> {
        let url_ = this.baseUrl + "/Flight/GetFlights";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFlights(_response);
        });
    }

    protected processGetFlights(response: AxiosResponse): Promise<Flight[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Flight.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Flight[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Flight[]>(null as any);
    }

    /**
     * @return Success
     */
    getIncidentTypes(  cancelToken?: CancelToken | undefined): Promise<IncidentTypeDtoListBaseResponse> {
        let url_ = this.baseUrl + "/Incident/GetIncidentTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIncidentTypes(_response);
        });
    }

    protected processGetIncidentTypes(response: AxiosResponse): Promise<IncidentTypeDtoListBaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IncidentTypeDtoListBaseResponse.fromJS(resultData200);
            return Promise.resolve<IncidentTypeDtoListBaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IncidentTypeDtoListBaseResponse>(null as any);
    }

    /**
     * @param name (optional) 
     * @param iconFile (optional) 
     * @return Success
     */
    addIncidentType(name: string | undefined, iconFile: FileParameter | undefined , cancelToken?: CancelToken | undefined): Promise<IncidentTypeDtoBaseResponse> {
        let url_ = this.baseUrl + "/Incident/AddIncidentType?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (iconFile === null || iconFile === undefined)
            throw new Error("The parameter 'iconFile' cannot be null.");
        else
            content_.append("iconFile", iconFile.data, iconFile.fileName ? iconFile.fileName : "iconFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddIncidentType(_response);
        });
    }

    protected processAddIncidentType(response: AxiosResponse): Promise<IncidentTypeDtoBaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IncidentTypeDtoBaseResponse.fromJS(resultData200);
            return Promise.resolve<IncidentTypeDtoBaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IncidentTypeDtoBaseResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addIncidentTypeTranslation(body: TranslationRequest | undefined , cancelToken?: CancelToken | undefined): Promise<TranslationBaseResponse> {
        let url_ = this.baseUrl + "/Incident/AddIncidentTypeTranslation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddIncidentTypeTranslation(_response);
        });
    }

    protected processAddIncidentTypeTranslation(response: AxiosResponse): Promise<TranslationBaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TranslationBaseResponse.fromJS(resultData200);
            return Promise.resolve<TranslationBaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TranslationBaseResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateIncidentTypeTranslation(body: TranslationRequest | undefined , cancelToken?: CancelToken | undefined): Promise<TranslationBaseResponse> {
        let url_ = this.baseUrl + "/Incident/UpdateIncidentTypeTranslation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateIncidentTypeTranslation(_response);
        });
    }

    protected processUpdateIncidentTypeTranslation(response: AxiosResponse): Promise<TranslationBaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TranslationBaseResponse.fromJS(resultData200);
            return Promise.resolve<TranslationBaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TranslationBaseResponse>(null as any);
    }

    /**
     * @param incidentTypeId (optional) 
     * @param iconFile (optional) 
     * @return Success
     */
    updateIncidentTypeIcon(incidentTypeId: string | undefined, iconFile: FileParameter | undefined , cancelToken?: CancelToken | undefined): Promise<IncidentTypeDtoBaseResponse> {
        let url_ = this.baseUrl + "/Incident/UpdateIncidentTypeIcon?";
        if (incidentTypeId === null)
            throw new Error("The parameter 'incidentTypeId' cannot be null.");
        else if (incidentTypeId !== undefined)
            url_ += "incidentTypeId=" + encodeURIComponent("" + incidentTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (iconFile === null || iconFile === undefined)
            throw new Error("The parameter 'iconFile' cannot be null.");
        else
            content_.append("iconFile", iconFile.data, iconFile.fileName ? iconFile.fileName : "iconFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateIncidentTypeIcon(_response);
        });
    }

    protected processUpdateIncidentTypeIcon(response: AxiosResponse): Promise<IncidentTypeDtoBaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IncidentTypeDtoBaseResponse.fromJS(resultData200);
            return Promise.resolve<IncidentTypeDtoBaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IncidentTypeDtoBaseResponse>(null as any);
    }

    /**
     * @param incidentTypeId (optional) 
     * @return Success
     */
    deleteIncidentType(incidentTypeId: string | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Incident/DeleteIncidentType?";
        if (incidentTypeId === null)
            throw new Error("The parameter 'incidentTypeId' cannot be null.");
        else if (incidentTypeId !== undefined)
            url_ += "incidentTypeId=" + encodeURIComponent("" + incidentTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteIncidentType(_response);
        });
    }

    protected processDeleteIncidentType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addIncident(body: IncidentAddRequest | undefined , cancelToken?: CancelToken | undefined): Promise<IncidentBaseResponse> {
        let url_ = this.baseUrl + "/Incident/AddIncident";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddIncident(_response);
        });
    }

    protected processAddIncident(response: AxiosResponse): Promise<IncidentBaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IncidentBaseResponse.fromJS(resultData200);
            return Promise.resolve<IncidentBaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IncidentBaseResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addIncidentTranslation(body: TranslationRequest | undefined , cancelToken?: CancelToken | undefined): Promise<TranslationBaseResponse> {
        let url_ = this.baseUrl + "/Incident/AddIncidentTranslation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddIncidentTranslation(_response);
        });
    }

    protected processAddIncidentTranslation(response: AxiosResponse): Promise<TranslationBaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TranslationBaseResponse.fromJS(resultData200);
            return Promise.resolve<TranslationBaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TranslationBaseResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateIncidentTranslation(body: TranslationRequest | undefined , cancelToken?: CancelToken | undefined): Promise<TranslationBaseResponse> {
        let url_ = this.baseUrl + "/Incident/UpdateIncidentTranslation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateIncidentTranslation(_response);
        });
    }

    protected processUpdateIncidentTranslation(response: AxiosResponse): Promise<TranslationBaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TranslationBaseResponse.fromJS(resultData200);
            return Promise.resolve<TranslationBaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TranslationBaseResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchIncidents(body: IncidentSearchCriteriaPageableSearch | undefined , cancelToken?: CancelToken | undefined): Promise<IncidentDtoPageableResponse> {
        let url_ = this.baseUrl + "/Incident/SearchIncidents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchIncidents(_response);
        });
    }

    protected processSearchIncidents(response: AxiosResponse): Promise<IncidentDtoPageableResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IncidentDtoPageableResponse.fromJS(resultData200);
            return Promise.resolve<IncidentDtoPageableResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IncidentDtoPageableResponse>(null as any);
    }

    /**
     * @param incidentId (optional) 
     * @return Success
     */
    deleteIncident(incidentId: string | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Incident/DeleteIncident?";
        if (incidentId === null)
            throw new Error("The parameter 'incidentId' cannot be null.");
        else if (incidentId !== undefined)
            url_ += "incidentId=" + encodeURIComponent("" + incidentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteIncident(_response);
        });
    }

    protected processDeleteIncident(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateIncident(body: IncidentUpdateRequest | undefined , cancelToken?: CancelToken | undefined): Promise<Incident> {
        let url_ = this.baseUrl + "/Incident/UpdateIncident";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateIncident(_response);
        });
    }

    protected processUpdateIncident(response: AxiosResponse): Promise<Incident> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Incident.fromJS(resultData200);
            return Promise.resolve<Incident>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Incident>(null as any);
    }

    /**
     * @return Success
     */
    getIssueCategories(  cancelToken?: CancelToken | undefined): Promise<IssueCategoryDtoListBaseResponse> {
        let url_ = this.baseUrl + "/Issue/GetIssueCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIssueCategories(_response);
        });
    }

    protected processGetIssueCategories(response: AxiosResponse): Promise<IssueCategoryDtoListBaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueCategoryDtoListBaseResponse.fromJS(resultData200);
            return Promise.resolve<IssueCategoryDtoListBaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueCategoryDtoListBaseResponse>(null as any);
    }

    /**
     * @param name (optional) 
     * @return Success
     */
    addIssueCategory(name: string | undefined , cancelToken?: CancelToken | undefined): Promise<IssueCategoryDtoBaseResponse> {
        let url_ = this.baseUrl + "/Issue/AddIssueCategory?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddIssueCategory(_response);
        });
    }

    protected processAddIssueCategory(response: AxiosResponse): Promise<IssueCategoryDtoBaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueCategoryDtoBaseResponse.fromJS(resultData200);
            return Promise.resolve<IssueCategoryDtoBaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueCategoryDtoBaseResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addIssueCategoryTranslation(body: TranslationRequest | undefined , cancelToken?: CancelToken | undefined): Promise<TranslationBaseResponse> {
        let url_ = this.baseUrl + "/Issue/AddIssueCategoryTranslation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddIssueCategoryTranslation(_response);
        });
    }

    protected processAddIssueCategoryTranslation(response: AxiosResponse): Promise<TranslationBaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TranslationBaseResponse.fromJS(resultData200);
            return Promise.resolve<TranslationBaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TranslationBaseResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateIssueCategoryTranslation(body: TranslationRequest | undefined , cancelToken?: CancelToken | undefined): Promise<TranslationBaseResponse> {
        let url_ = this.baseUrl + "/Issue/UpdateIssueCategoryTranslation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateIssueCategoryTranslation(_response);
        });
    }

    protected processUpdateIssueCategoryTranslation(response: AxiosResponse): Promise<TranslationBaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TranslationBaseResponse.fromJS(resultData200);
            return Promise.resolve<TranslationBaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TranslationBaseResponse>(null as any);
    }

    /**
     * @param issueCategoryId (optional) 
     * @return Success
     */
    deleteIssueCategory(issueCategoryId: string | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Issue/DeleteIssueCategory?";
        if (issueCategoryId === null)
            throw new Error("The parameter 'issueCategoryId' cannot be null.");
        else if (issueCategoryId !== undefined)
            url_ += "issueCategoryId=" + encodeURIComponent("" + issueCategoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteIssueCategory(_response);
        });
    }

    protected processDeleteIssueCategory(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchIssues(body: IssueSearchCriteriaPageableSearch | undefined , cancelToken?: CancelToken | undefined): Promise<IssuePageableResponse> {
        let url_ = this.baseUrl + "/Issue/SearchIssues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchIssues(_response);
        });
    }

    protected processSearchIssues(response: AxiosResponse): Promise<IssuePageableResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssuePageableResponse.fromJS(resultData200);
            return Promise.resolve<IssuePageableResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssuePageableResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addIssue(body: IssueAddRequest | undefined , cancelToken?: CancelToken | undefined): Promise<Issue> {
        let url_ = this.baseUrl + "/Issue/AddIssue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddIssue(_response);
        });
    }

    protected processAddIssue(response: AxiosResponse): Promise<Issue> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Issue.fromJS(resultData200);
            return Promise.resolve<Issue>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Issue>(null as any);
    }

    /**
     * @param issueId (optional) 
     * @param files (optional) 
     * @return Success
     */
    uploadIssueFiles(issueId: string | undefined, files: FileParameter | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Issue/UploadIssueFiles?";
        if (issueId === null)
            throw new Error("The parameter 'issueId' cannot be null.");
        else if (issueId !== undefined)
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            content_.append("files", files.data, files.fileName ? files.fileName : "files");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadIssueFiles(_response);
        });
    }

    protected processUploadIssueFiles(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    operatorProcessOnIssue(body: IssueUpdateRequest | undefined , cancelToken?: CancelToken | undefined): Promise<Issue> {
        let url_ = this.baseUrl + "/Issue/OperatorProcessOnIssue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperatorProcessOnIssue(_response);
        });
    }

    protected processOperatorProcessOnIssue(response: AxiosResponse): Promise<Issue> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Issue.fromJS(resultData200);
            return Promise.resolve<Issue>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Issue>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addMayor(body: MayorAddRequest | undefined , cancelToken?: CancelToken | undefined): Promise<Mayor> {
        let url_ = this.baseUrl + "/Mayor/AddMayor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddMayor(_response);
        });
    }

    protected processAddMayor(response: AxiosResponse): Promise<Mayor> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Mayor.fromJS(resultData200);
            return Promise.resolve<Mayor>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Mayor>(null as any);
    }

    /**
     * @param cityCode (optional) 
     * @return Success
     */
    getMayor(cityCode: number | undefined , cancelToken?: CancelToken | undefined): Promise<Mayor> {
        let url_ = this.baseUrl + "/Mayor/GetMayor?";
        if (cityCode === null)
            throw new Error("The parameter 'cityCode' cannot be null.");
        else if (cityCode !== undefined)
            url_ += "cityCode=" + encodeURIComponent("" + cityCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMayor(_response);
        });
    }

    protected processGetMayor(response: AxiosResponse): Promise<Mayor> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Mayor.fromJS(resultData200);
            return Promise.resolve<Mayor>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Mayor>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMayor(body: MayorUpdateRequest | undefined , cancelToken?: CancelToken | undefined): Promise<Mayor> {
        let url_ = this.baseUrl + "/Mayor/UpdateMayor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMayor(_response);
        });
    }

    protected processUpdateMayor(response: AxiosResponse): Promise<Mayor> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Mayor.fromJS(resultData200);
            return Promise.resolve<Mayor>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Mayor>(null as any);
    }

    /**
     * @param mayorId (optional) 
     * @return Success
     */
    deleteMayor(mayorId: string | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Mayor/DeleteMayor?";
        if (mayorId === null)
            throw new Error("The parameter 'mayorId' cannot be null.");
        else if (mayorId !== undefined)
            url_ += "mayorId=" + encodeURIComponent("" + mayorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMayor(_response);
        });
    }

    protected processDeleteMayor(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param cityCode (optional) 
     * @param file (optional) 
     * @return Success
     */
    uploadMayorPhoto(cityCode: number | undefined, file: FileParameter | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/Mayor/UploadMayorPhoto?";
        if (cityCode === null)
            throw new Error("The parameter 'cityCode' cannot be null.");
        else if (cityCode !== undefined)
            url_ += "cityCode=" + encodeURIComponent("" + cityCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadMayorPhoto(_response);
        });
    }

    protected processUploadMayorPhoto(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param cityCode (optional) 
     * @return Success
     */
    deleteMayorPhoto(cityCode: number | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/Mayor/DeleteMayorPhoto?";
        if (cityCode === null)
            throw new Error("The parameter 'cityCode' cannot be null.");
        else if (cityCode !== undefined)
            url_ += "cityCode=" + encodeURIComponent("" + cityCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMayorPhoto(_response);
        });
    }

    protected processDeleteMayorPhoto(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNews(body: NewsAddRequest | undefined , cancelToken?: CancelToken | undefined): Promise<News> {
        let url_ = this.baseUrl + "/News/AddNews";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddNews(_response);
        });
    }

    protected processAddNews(response: AxiosResponse): Promise<News> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = News.fromJS(resultData200);
            return Promise.resolve<News>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<News>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchNews(body: NewsSearchCriteriaPageableSearch | undefined , cancelToken?: CancelToken | undefined): Promise<NewsDTOPageableResponse> {
        let url_ = this.baseUrl + "/News/SearchNews";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchNews(_response);
        });
    }

    protected processSearchNews(response: AxiosResponse): Promise<NewsDTOPageableResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NewsDTOPageableResponse.fromJS(resultData200);
            return Promise.resolve<NewsDTOPageableResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NewsDTOPageableResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateNews(body: NewsUpdateRequest | undefined , cancelToken?: CancelToken | undefined): Promise<NewsBaseResponse> {
        let url_ = this.baseUrl + "/News/UpdateNews";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateNews(_response);
        });
    }

    protected processUpdateNews(response: AxiosResponse): Promise<NewsBaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NewsBaseResponse.fromJS(resultData200);
            return Promise.resolve<NewsBaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NewsBaseResponse>(null as any);
    }

    /**
     * @param newsId (optional) 
     * @return Success
     */
    deleteNews(newsId: string | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/News/DeleteNews?";
        if (newsId === null)
            throw new Error("The parameter 'newsId' cannot be null.");
        else if (newsId !== undefined)
            url_ += "newsId=" + encodeURIComponent("" + newsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteNews(_response);
        });
    }

    protected processDeleteNews(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param newsId (optional) 
     * @return Success
     */
    archiveNews(newsId: string | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/News/ArchiveNews?";
        if (newsId === null)
            throw new Error("The parameter 'newsId' cannot be null.");
        else if (newsId !== undefined)
            url_ += "newsId=" + encodeURIComponent("" + newsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processArchiveNews(_response);
        });
    }

    protected processArchiveNews(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param newsId (optional) 
     * @return Success
     */
    unarchiveNews(newsId: string | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/News/UnarchiveNews?";
        if (newsId === null)
            throw new Error("The parameter 'newsId' cannot be null.");
        else if (newsId !== undefined)
            url_ += "newsId=" + encodeURIComponent("" + newsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnarchiveNews(_response);
        });
    }

    protected processUnarchiveNews(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param newsId (optional) 
     * @param file (optional) 
     * @return Success
     */
    uploadNewsAsset(newsId: string | undefined, file: FileParameter | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/News/UploadNewsAsset?";
        if (newsId === null)
            throw new Error("The parameter 'newsId' cannot be null.");
        else if (newsId !== undefined)
            url_ += "newsId=" + encodeURIComponent("" + newsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadNewsAsset(_response);
        });
    }

    protected processUploadNewsAsset(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param newsId (optional) 
     * @param newsAssetId (optional) 
     * @return Success
     */
    deleteNewsAsset(newsId: string | undefined, newsAssetId: string | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/News/DeleteNewsAsset?";
        if (newsId === null)
            throw new Error("The parameter 'newsId' cannot be null.");
        else if (newsId !== undefined)
            url_ += "newsId=" + encodeURIComponent("" + newsId) + "&";
        if (newsAssetId === null)
            throw new Error("The parameter 'newsAssetId' cannot be null.");
        else if (newsAssetId !== undefined)
            url_ += "newsAssetId=" + encodeURIComponent("" + newsAssetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteNewsAsset(_response);
        });
    }

    protected processDeleteNewsAsset(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param cityCode (optional) 
     * @param title (optional) 
     * @param content (optional) 
     * @return Success
     */
    sendBroadCastMessage(cityCode: number | undefined, title: string | undefined, content: string | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/OneSignal/SendBroadCastMessage?";
        if (cityCode === null)
            throw new Error("The parameter 'cityCode' cannot be null.");
        else if (cityCode !== undefined)
            url_ += "cityCode=" + encodeURIComponent("" + cityCode) + "&";
        if (title === null)
            throw new Error("The parameter 'title' cannot be null.");
        else if (title !== undefined)
            url_ += "title=" + encodeURIComponent("" + title) + "&";
        if (content === null)
            throw new Error("The parameter 'content' cannot be null.");
        else if (content !== undefined)
            url_ += "content=" + encodeURIComponent("" + content) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendBroadCastMessage(_response);
        });
    }

    protected processSendBroadCastMessage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param cityCode (optional) 
     * @param playerId (optional) 
     * @param title (optional) 
     * @param content (optional) 
     * @return Success
     */
    sendSpesificMessage(cityCode: number | undefined, playerId: string | undefined, title: string | undefined, content: string | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/OneSignal/SendSpesificMessage?";
        if (cityCode === null)
            throw new Error("The parameter 'cityCode' cannot be null.");
        else if (cityCode !== undefined)
            url_ += "cityCode=" + encodeURIComponent("" + cityCode) + "&";
        if (playerId === null)
            throw new Error("The parameter 'playerId' cannot be null.");
        else if (playerId !== undefined)
            url_ += "playerId=" + encodeURIComponent("" + playerId) + "&";
        if (title === null)
            throw new Error("The parameter 'title' cannot be null.");
        else if (title !== undefined)
            url_ += "title=" + encodeURIComponent("" + title) + "&";
        if (content === null)
            throw new Error("The parameter 'content' cannot be null.");
        else if (content !== undefined)
            url_ += "content=" + encodeURIComponent("" + content) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendSpesificMessage(_response);
        });
    }

    protected processSendSpesificMessage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param cityCode (optional) 
     * @param playerId (optional) 
     * @return Success
     */
    getNotifications(cityCode: number | undefined, playerId: string | undefined , cancelToken?: CancelToken | undefined): Promise<NotificationDto[]> {
        let url_ = this.baseUrl + "/OneSignal/GetNotifications?";
        if (cityCode === null)
            throw new Error("The parameter 'cityCode' cannot be null.");
        else if (cityCode !== undefined)
            url_ += "cityCode=" + encodeURIComponent("" + cityCode) + "&";
        if (playerId === null)
            throw new Error("The parameter 'playerId' cannot be null.");
        else if (playerId !== undefined)
            url_ += "playerId=" + encodeURIComponent("" + playerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNotifications(_response);
        });
    }

    protected processGetNotifications(response: AxiosResponse): Promise<NotificationDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<NotificationDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NotificationDto[]>(null as any);
    }

    /**
     * @param cityCode (optional) 
     * @return Success
     */
    getPharmaciesOnDuty(cityCode: number | undefined , cancelToken?: CancelToken | undefined): Promise<PharmacyListBaseResponse> {
        let url_ = this.baseUrl + "/Pharmacy/GetPharmaciesOnDuty?";
        if (cityCode === null)
            throw new Error("The parameter 'cityCode' cannot be null.");
        else if (cityCode !== undefined)
            url_ += "cityCode=" + encodeURIComponent("" + cityCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPharmaciesOnDuty(_response);
        });
    }

    protected processGetPharmaciesOnDuty(response: AxiosResponse): Promise<PharmacyListBaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PharmacyListBaseResponse.fromJS(resultData200);
            return Promise.resolve<PharmacyListBaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PharmacyListBaseResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchPlaces(body: PlaceSearchCriteriaPageableSearch | undefined , cancelToken?: CancelToken | undefined): Promise<PlacePageableResponse> {
        let url_ = this.baseUrl + "/Place/SearchPlaces";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchPlaces(_response);
        });
    }

    protected processSearchPlaces(response: AxiosResponse): Promise<PlacePageableResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PlacePageableResponse.fromJS(resultData200);
            return Promise.resolve<PlacePageableResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlacePageableResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addPlace(body: PlaceAddRequest | undefined , cancelToken?: CancelToken | undefined): Promise<PlaceBaseResponse> {
        let url_ = this.baseUrl + "/Place/AddPlace";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddPlace(_response);
        });
    }

    protected processAddPlace(response: AxiosResponse): Promise<PlaceBaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PlaceBaseResponse.fromJS(resultData200);
            return Promise.resolve<PlaceBaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlaceBaseResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePlace(body: PlaceUpdateRequest | undefined , cancelToken?: CancelToken | undefined): Promise<PlaceBaseResponse> {
        let url_ = this.baseUrl + "/Place/UpdatePlace";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePlace(_response);
        });
    }

    protected processUpdatePlace(response: AxiosResponse): Promise<PlaceBaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PlaceBaseResponse.fromJS(resultData200);
            return Promise.resolve<PlaceBaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlaceBaseResponse>(null as any);
    }

    /**
     * @param placeId (optional) 
     * @return Success
     */
    deletePlace(placeId: string | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Place/DeletePlace?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePlace(_response);
        });
    }

    protected processDeletePlace(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param placeId (optional) 
     * @param file (optional) 
     * @return Success
     */
    uploadPlaceAsset(placeId: string | undefined, file: FileParameter | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/Place/UploadPlaceAsset?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadPlaceAsset(_response);
        });
    }

    protected processUploadPlaceAsset(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param placeId (optional) 
     * @param placeAssetId (optional) 
     * @return Success
     */
    deletePlaceAsset(placeId: string | undefined, placeAssetId: string | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/Place/DeletePlaceAsset?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        if (placeAssetId === null)
            throw new Error("The parameter 'placeAssetId' cannot be null.");
        else if (placeAssetId !== undefined)
            url_ += "placeAssetId=" + encodeURIComponent("" + placeAssetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePlaceAsset(_response);
        });
    }

    protected processDeletePlaceAsset(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param name (optional) 
     * @return Success
     */
    poiSearch(name: string | undefined , cancelToken?: CancelToken | undefined): Promise<Place[]> {
        let url_ = this.baseUrl + "/PoiSuggestion/PoiSearch?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPoiSearch(_response);
        });
    }

    protected processPoiSearch(response: AxiosResponse): Promise<Place[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Place.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Place[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Place[]>(null as any);
    }

    /**
     * @return Success
     */
    getRealms(  cancelToken?: CancelToken | undefined): Promise<RealmDtoListBaseResponse> {
        let url_ = this.baseUrl + "/Realm/GetRealms";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRealms(_response);
        });
    }

    protected processGetRealms(response: AxiosResponse): Promise<RealmDtoListBaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RealmDtoListBaseResponse.fromJS(resultData200);
            return Promise.resolve<RealmDtoListBaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RealmDtoListBaseResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addRoute(body: RouteAddRequest | undefined , cancelToken?: CancelToken | undefined): Promise<RouteBaseResponse> {
        let url_ = this.baseUrl + "/Route/AddRoute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddRoute(_response);
        });
    }

    protected processAddRoute(response: AxiosResponse): Promise<RouteBaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RouteBaseResponse.fromJS(resultData200);
            return Promise.resolve<RouteBaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RouteBaseResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getRoutes(body: string[] | undefined , cancelToken?: CancelToken | undefined): Promise<RouteListBaseResponse> {
        let url_ = this.baseUrl + "/Route/GetRoutes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRoutes(_response);
        });
    }

    protected processGetRoutes(response: AxiosResponse): Promise<RouteListBaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RouteListBaseResponse.fromJS(resultData200);
            return Promise.resolve<RouteListBaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RouteListBaseResponse>(null as any);
    }
}

export class AQIStationDetail implements IAQIStationDetail {
    name?: string | undefined;
    city?: string | undefined;
    county?: string | undefined;
    lat?: number;
    lon?: number;
    aqiValue?: number;
    aqiStatus?: number;
    measurementDate?: Date;
    standardActivity?: string | undefined;
    sensitiveActivity?: string | undefined;
    statusDescription?: string | undefined;
    activityRecommendations?: string[] | undefined;
    color?: string | undefined;

    constructor(data?: IAQIStationDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.city = _data["city"];
            this.county = _data["county"];
            this.lat = _data["lat"];
            this.lon = _data["lon"];
            this.aqiValue = _data["aqiValue"];
            this.aqiStatus = _data["aqiStatus"];
            this.measurementDate = _data["measurementDate"] ? new Date(_data["measurementDate"].toString()) : <any>undefined;
            this.standardActivity = _data["standardActivity"];
            this.sensitiveActivity = _data["sensitiveActivity"];
            this.statusDescription = _data["statusDescription"];
            if (Array.isArray(_data["activityRecommendations"])) {
                this.activityRecommendations = [] as any;
                for (let item of _data["activityRecommendations"])
                    this.activityRecommendations!.push(item);
            }
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): AQIStationDetail {
        data = typeof data === 'object' ? data : {};
        let result = new AQIStationDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["city"] = this.city;
        data["county"] = this.county;
        data["lat"] = this.lat;
        data["lon"] = this.lon;
        data["aqiValue"] = this.aqiValue;
        data["aqiStatus"] = this.aqiStatus;
        data["measurementDate"] = this.measurementDate ? this.measurementDate.toISOString() : <any>undefined;
        data["standardActivity"] = this.standardActivity;
        data["sensitiveActivity"] = this.sensitiveActivity;
        data["statusDescription"] = this.statusDescription;
        if (Array.isArray(this.activityRecommendations)) {
            data["activityRecommendations"] = [];
            for (let item of this.activityRecommendations)
                data["activityRecommendations"].push(item);
        }
        data["color"] = this.color;
        return data;
    }
}

export interface IAQIStationDetail {
    name?: string | undefined;
    city?: string | undefined;
    county?: string | undefined;
    lat?: number;
    lon?: number;
    aqiValue?: number;
    aqiStatus?: number;
    measurementDate?: Date;
    standardActivity?: string | undefined;
    sensitiveActivity?: string | undefined;
    statusDescription?: string | undefined;
    activityRecommendations?: string[] | undefined;
    color?: string | undefined;
}

export class AQIStationDetailListBaseResponse implements IAQIStationDetailListBaseResponse {
    data?: AQIStationDetail[] | undefined;

    constructor(data?: IAQIStationDetailListBaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AQIStationDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AQIStationDetailListBaseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AQIStationDetailListBaseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAQIStationDetailListBaseResponse {
    data?: AQIStationDetail[] | undefined;
}

export class Category implements ICategory {
    id?: string;
    cityCode?: number;
    name?: string | undefined;
    descriptionId?: string;
    description?: TextContent;
    icon?: string | undefined;
    isVisible?: number;
    parentCategoryId?: string | undefined;
    parentCategory?: Category;
    children?: Category[] | undefined;
    categoryExtraFields?: CategoryExtraField[] | undefined;

    constructor(data?: ICategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cityCode = _data["cityCode"];
            this.name = _data["name"];
            this.descriptionId = _data["descriptionId"];
            this.description = _data["description"] ? TextContent.fromJS(_data["description"]) : <any>undefined;
            this.icon = _data["icon"];
            this.isVisible = _data["isVisible"];
            this.parentCategoryId = _data["parentCategoryId"];
            this.parentCategory = _data["parentCategory"] ? Category.fromJS(_data["parentCategory"]) : <any>undefined;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(Category.fromJS(item));
            }
            if (Array.isArray(_data["categoryExtraFields"])) {
                this.categoryExtraFields = [] as any;
                for (let item of _data["categoryExtraFields"])
                    this.categoryExtraFields!.push(CategoryExtraField.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Category {
        data = typeof data === 'object' ? data : {};
        let result = new Category();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cityCode"] = this.cityCode;
        data["name"] = this.name;
        data["descriptionId"] = this.descriptionId;
        data["description"] = this.description ? this.description.toJSON() : <any>undefined;
        data["icon"] = this.icon;
        data["isVisible"] = this.isVisible;
        data["parentCategoryId"] = this.parentCategoryId;
        data["parentCategory"] = this.parentCategory ? this.parentCategory.toJSON() : <any>undefined;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        if (Array.isArray(this.categoryExtraFields)) {
            data["categoryExtraFields"] = [];
            for (let item of this.categoryExtraFields)
                data["categoryExtraFields"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICategory {
    id?: string;
    cityCode?: number;
    name?: string | undefined;
    descriptionId?: string;
    description?: TextContent;
    icon?: string | undefined;
    isVisible?: number;
    parentCategoryId?: string | undefined;
    parentCategory?: Category;
    children?: Category[] | undefined;
    categoryExtraFields?: CategoryExtraField[] | undefined;
}

export class CategoryAddRequest implements ICategoryAddRequest {
    cityCode?: number;
    name?: string | undefined;
    icon?: string | undefined;
    isVisible?: number;
    categoryGroupId?: string | undefined;

    constructor(data?: ICategoryAddRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cityCode = _data["cityCode"];
            this.name = _data["name"];
            this.icon = _data["icon"];
            this.isVisible = _data["isVisible"];
            this.categoryGroupId = _data["categoryGroupId"];
        }
    }

    static fromJS(data: any): CategoryAddRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryAddRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cityCode"] = this.cityCode;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["isVisible"] = this.isVisible;
        data["categoryGroupId"] = this.categoryGroupId;
        return data;
    }
}

export interface ICategoryAddRequest {
    cityCode?: number;
    name?: string | undefined;
    icon?: string | undefined;
    isVisible?: number;
    categoryGroupId?: string | undefined;
}

export class CategoryBaseResponse implements ICategoryBaseResponse {
    data?: Category;

    constructor(data?: ICategoryBaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? Category.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CategoryBaseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryBaseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICategoryBaseResponse {
    data?: Category;
}

export class CategoryExtraField implements ICategoryExtraField {
    id?: string;
    categoryId?: string;
    fieldNameId?: string;
    fieldType?: FieldTypes;
    fieldName?: TextContent;
    category?: Category;

    constructor(data?: ICategoryExtraField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.categoryId = _data["categoryId"];
            this.fieldNameId = _data["fieldNameId"];
            this.fieldType = _data["fieldType"];
            this.fieldName = _data["fieldName"] ? TextContent.fromJS(_data["fieldName"]) : <any>undefined;
            this.category = _data["category"] ? Category.fromJS(_data["category"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CategoryExtraField {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryExtraField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["categoryId"] = this.categoryId;
        data["fieldNameId"] = this.fieldNameId;
        data["fieldType"] = this.fieldType;
        data["fieldName"] = this.fieldName ? this.fieldName.toJSON() : <any>undefined;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICategoryExtraField {
    id?: string;
    categoryId?: string;
    fieldNameId?: string;
    fieldType?: FieldTypes;
    fieldName?: TextContent;
    category?: Category;
}

export class CategoryExtraFieldBaseResponse implements ICategoryExtraFieldBaseResponse {
    data?: CategoryExtraField;

    constructor(data?: ICategoryExtraFieldBaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? CategoryExtraField.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CategoryExtraFieldBaseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryExtraFieldBaseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICategoryExtraFieldBaseResponse {
    data?: CategoryExtraField;
}

export class CategoryGroupAddRequest implements ICategoryGroupAddRequest {
    cityCode?: number;
    name?: string | undefined;
    icon?: string | undefined;
    isVisible?: number;

    constructor(data?: ICategoryGroupAddRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cityCode = _data["cityCode"];
            this.name = _data["name"];
            this.icon = _data["icon"];
            this.isVisible = _data["isVisible"];
        }
    }

    static fromJS(data: any): CategoryGroupAddRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryGroupAddRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cityCode"] = this.cityCode;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["isVisible"] = this.isVisible;
        return data;
    }
}

export interface ICategoryGroupAddRequest {
    cityCode?: number;
    name?: string | undefined;
    icon?: string | undefined;
    isVisible?: number;
}

export class CategoryListBaseResponse implements ICategoryListBaseResponse {
    data?: Category[] | undefined;

    constructor(data?: ICategoryListBaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Category.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CategoryListBaseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryListBaseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICategoryListBaseResponse {
    data?: Category[] | undefined;
}

export class CategoryUpdateRequest implements ICategoryUpdateRequest {
    categoryId?: string;
    cityCode?: number | undefined;
    name?: string | undefined;
    icon?: string | undefined;
    isVisible?: number;
    parentCategoryId?: string | undefined;

    constructor(data?: ICategoryUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
            this.cityCode = _data["cityCode"];
            this.name = _data["name"];
            this.icon = _data["icon"];
            this.isVisible = _data["isVisible"];
            this.parentCategoryId = _data["parentCategoryId"];
        }
    }

    static fromJS(data: any): CategoryUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["cityCode"] = this.cityCode;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["isVisible"] = this.isVisible;
        data["parentCategoryId"] = this.parentCategoryId;
        return data;
    }
}

export interface ICategoryUpdateRequest {
    categoryId?: string;
    cityCode?: number | undefined;
    name?: string | undefined;
    icon?: string | undefined;
    isVisible?: number;
    parentCategoryId?: string | undefined;
}

export class City implements ICity {
    code?: number;
    name?: string | undefined;
    lat?: number;
    lon?: number;

    constructor(data?: ICity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.lat = _data["lat"];
            this.lon = _data["lon"];
        }
    }

    static fromJS(data: any): City {
        data = typeof data === 'object' ? data : {};
        let result = new City();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["lat"] = this.lat;
        data["lon"] = this.lon;
        return data;
    }
}

export interface ICity {
    code?: number;
    name?: string | undefined;
    lat?: number;
    lon?: number;
}

export class CityBaseResponse implements ICityBaseResponse {
    data?: City;

    constructor(data?: ICityBaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? City.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CityBaseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CityBaseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICityBaseResponse {
    data?: City;
}

export class CityListBaseResponse implements ICityListBaseResponse {
    data?: City[] | undefined;

    constructor(data?: ICityListBaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(City.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CityListBaseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CityListBaseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICityListBaseResponse {
    data?: City[] | undefined;
}

export class Coordinate implements ICoordinate {
    x?: number;
    y?: number;
    z?: number;
    m?: number;
    coordinateValue?: Coordinate;

    constructor(data?: ICoordinate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"];
            this.y = _data["y"];
            this.z = _data["z"];
            this.m = _data["m"];
            this.coordinateValue = _data["coordinateValue"] ? Coordinate.fromJS(_data["coordinateValue"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Coordinate {
        data = typeof data === 'object' ? data : {};
        let result = new Coordinate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        data["z"] = this.z;
        data["m"] = this.m;
        data["coordinateValue"] = this.coordinateValue ? this.coordinateValue.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICoordinate {
    x?: number;
    y?: number;
    z?: number;
    m?: number;
    coordinateValue?: Coordinate;
}

export class CoordinateSequence implements ICoordinateSequence {
    readonly dimension?: number;
    readonly measures?: number;
    readonly spatial?: number;
    ordinates?: Ordinates;
    readonly hasZ?: boolean;
    readonly hasM?: boolean;
    readonly zOrdinateIndex?: number;
    readonly mOrdinateIndex?: number;
    readonly count?: number;

    constructor(data?: ICoordinateSequence) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).dimension = _data["dimension"];
            (<any>this).measures = _data["measures"];
            (<any>this).spatial = _data["spatial"];
            this.ordinates = _data["ordinates"];
            (<any>this).hasZ = _data["hasZ"];
            (<any>this).hasM = _data["hasM"];
            (<any>this).zOrdinateIndex = _data["zOrdinateIndex"];
            (<any>this).mOrdinateIndex = _data["mOrdinateIndex"];
            (<any>this).count = _data["count"];
        }
    }

    static fromJS(data: any): CoordinateSequence {
        data = typeof data === 'object' ? data : {};
        let result = new CoordinateSequence();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimension"] = this.dimension;
        data["measures"] = this.measures;
        data["spatial"] = this.spatial;
        data["ordinates"] = this.ordinates;
        data["hasZ"] = this.hasZ;
        data["hasM"] = this.hasM;
        data["zOrdinateIndex"] = this.zOrdinateIndex;
        data["mOrdinateIndex"] = this.mOrdinateIndex;
        data["count"] = this.count;
        return data;
    }
}

export interface ICoordinateSequence {
    dimension?: number;
    measures?: number;
    spatial?: number;
    ordinates?: Ordinates;
    hasZ?: boolean;
    hasM?: boolean;
    zOrdinateIndex?: number;
    mOrdinateIndex?: number;
    count?: number;
}

export class CoordinateSequenceFactory implements ICoordinateSequenceFactory {
    ordinates?: Ordinates;

    constructor(data?: ICoordinateSequenceFactory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ordinates = _data["ordinates"];
        }
    }

    static fromJS(data: any): CoordinateSequenceFactory {
        data = typeof data === 'object' ? data : {};
        let result = new CoordinateSequenceFactory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ordinates"] = this.ordinates;
        return data;
    }
}

export interface ICoordinateSequenceFactory {
    ordinates?: Ordinates;
}

export class County implements ICounty {
    code?: number;
    name?: string | undefined;
    lat?: number;
    lon?: number;
    cityCode?: number;

    constructor(data?: ICounty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.lat = _data["lat"];
            this.lon = _data["lon"];
            this.cityCode = _data["cityCode"];
        }
    }

    static fromJS(data: any): County {
        data = typeof data === 'object' ? data : {};
        let result = new County();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["lat"] = this.lat;
        data["lon"] = this.lon;
        data["cityCode"] = this.cityCode;
        return data;
    }
}

export interface ICounty {
    code?: number;
    name?: string | undefined;
    lat?: number;
    lon?: number;
    cityCode?: number;
}

export class CountyAddRequest implements ICountyAddRequest {
    code?: number;
    name?: string | undefined;
    lat?: number;
    lon?: number;
    cityCode?: number;

    constructor(data?: ICountyAddRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.lat = _data["lat"];
            this.lon = _data["lon"];
            this.cityCode = _data["cityCode"];
        }
    }

    static fromJS(data: any): CountyAddRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CountyAddRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["lat"] = this.lat;
        data["lon"] = this.lon;
        data["cityCode"] = this.cityCode;
        return data;
    }
}

export interface ICountyAddRequest {
    code?: number;
    name?: string | undefined;
    lat?: number;
    lon?: number;
    cityCode?: number;
}

export class CountyBaseResponse implements ICountyBaseResponse {
    data?: County;

    constructor(data?: ICountyBaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? County.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CountyBaseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CountyBaseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICountyBaseResponse {
    data?: County;
}

export class CountyListBaseResponse implements ICountyListBaseResponse {
    data?: County[] | undefined;

    constructor(data?: ICountyListBaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(County.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CountyListBaseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CountyListBaseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICountyListBaseResponse {
    data?: County[] | undefined;
}

export enum Dimension {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    __3 = -3,
    __2 = -2,
    __1 = -1,
}

export class Envelope implements IEnvelope {
    readonly isNull?: boolean;
    readonly width?: number;
    readonly height?: number;
    readonly minX?: number;
    readonly maxX?: number;
    readonly minY?: number;
    readonly maxY?: number;
    readonly area?: number;
    readonly minExtent?: number;
    readonly maxExtent?: number;
    centre?: Coordinate;

    constructor(data?: IEnvelope) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).isNull = _data["isNull"];
            (<any>this).width = _data["width"];
            (<any>this).height = _data["height"];
            (<any>this).minX = _data["minX"];
            (<any>this).maxX = _data["maxX"];
            (<any>this).minY = _data["minY"];
            (<any>this).maxY = _data["maxY"];
            (<any>this).area = _data["area"];
            (<any>this).minExtent = _data["minExtent"];
            (<any>this).maxExtent = _data["maxExtent"];
            this.centre = _data["centre"] ? Coordinate.fromJS(_data["centre"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Envelope {
        data = typeof data === 'object' ? data : {};
        let result = new Envelope();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isNull"] = this.isNull;
        data["width"] = this.width;
        data["height"] = this.height;
        data["minX"] = this.minX;
        data["maxX"] = this.maxX;
        data["minY"] = this.minY;
        data["maxY"] = this.maxY;
        data["area"] = this.area;
        data["minExtent"] = this.minExtent;
        data["maxExtent"] = this.maxExtent;
        data["centre"] = this.centre ? this.centre.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEnvelope {
    isNull?: boolean;
    width?: number;
    height?: number;
    minX?: number;
    maxX?: number;
    minY?: number;
    maxY?: number;
    area?: number;
    minExtent?: number;
    maxExtent?: number;
    centre?: Coordinate;
}

export class ExtraFieldAddRequest implements IExtraFieldAddRequest {
    categoryId?: string;
    fieldName?: string | undefined;
    fieldType?: FieldTypes;

    constructor(data?: IExtraFieldAddRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
            this.fieldName = _data["fieldName"];
            this.fieldType = _data["fieldType"];
        }
    }

    static fromJS(data: any): ExtraFieldAddRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExtraFieldAddRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["fieldName"] = this.fieldName;
        data["fieldType"] = this.fieldType;
        return data;
    }
}

export interface IExtraFieldAddRequest {
    categoryId?: string;
    fieldName?: string | undefined;
    fieldType?: FieldTypes;
}

export class ExtraFieldUpdateRequest implements IExtraFieldUpdateRequest {
    categoryId?: string;
    fieldName?: string | undefined;
    fieldType?: FieldTypes;
    extraFieldId?: string;

    constructor(data?: IExtraFieldUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
            this.fieldName = _data["fieldName"];
            this.fieldType = _data["fieldType"];
            this.extraFieldId = _data["extraFieldId"];
        }
    }

    static fromJS(data: any): ExtraFieldUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExtraFieldUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["fieldName"] = this.fieldName;
        data["fieldType"] = this.fieldType;
        data["extraFieldId"] = this.extraFieldId;
        return data;
    }
}

export interface IExtraFieldUpdateRequest {
    categoryId?: string;
    fieldName?: string | undefined;
    fieldType?: FieldTypes;
    extraFieldId?: string;
}

export enum FieldTypes {
    _0 = 0,
    _1 = 1,
}

export class Flight implements IFlight {
    flightId?: string | undefined;
    type?: string | undefined;
    flightCode?: string | undefined;
    callSign?: string | undefined;
    airlineName?: string | undefined;
    airlineCode?: string | undefined;
    airlineImgUrl?: string | undefined;
    fromOrTo?: string | undefined;
    fromOrToIataCode?: string | undefined;
    scheduledTime?: string | undefined;
    estimatedTime?: string | undefined;
    exactTime?: string | undefined;
    gateNumber?: number | undefined;
    flightStatus?: string | undefined;
    flightStatusId?: number | undefined;
    terminal?: string | undefined;
    flightDate?: string | undefined;
    airportName?: string | undefined;
    airportIataCode?: string | undefined;
    airportIcaoCode?: string | undefined;
    liveUrl?: string | undefined;
    lastUpdateTime?: string | undefined;
    live?: boolean;

    constructor(data?: IFlight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flightId = _data["flightId"];
            this.type = _data["type"];
            this.flightCode = _data["flightCode"];
            this.callSign = _data["callSign"];
            this.airlineName = _data["airlineName"];
            this.airlineCode = _data["airlineCode"];
            this.airlineImgUrl = _data["airlineImgUrl"];
            this.fromOrTo = _data["fromOrTo"];
            this.fromOrToIataCode = _data["fromOrToIataCode"];
            this.scheduledTime = _data["scheduledTime"];
            this.estimatedTime = _data["estimatedTime"];
            this.exactTime = _data["exactTime"];
            this.gateNumber = _data["gateNumber"];
            this.flightStatus = _data["flightStatus"];
            this.flightStatusId = _data["flightStatusId"];
            this.terminal = _data["terminal"];
            this.flightDate = _data["flightDate"];
            this.airportName = _data["airportName"];
            this.airportIataCode = _data["airportIataCode"];
            this.airportIcaoCode = _data["airportIcaoCode"];
            this.liveUrl = _data["liveUrl"];
            this.lastUpdateTime = _data["lastUpdateTime"];
            this.live = _data["live"];
        }
    }

    static fromJS(data: any): Flight {
        data = typeof data === 'object' ? data : {};
        let result = new Flight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flightId"] = this.flightId;
        data["type"] = this.type;
        data["flightCode"] = this.flightCode;
        data["callSign"] = this.callSign;
        data["airlineName"] = this.airlineName;
        data["airlineCode"] = this.airlineCode;
        data["airlineImgUrl"] = this.airlineImgUrl;
        data["fromOrTo"] = this.fromOrTo;
        data["fromOrToIataCode"] = this.fromOrToIataCode;
        data["scheduledTime"] = this.scheduledTime;
        data["estimatedTime"] = this.estimatedTime;
        data["exactTime"] = this.exactTime;
        data["gateNumber"] = this.gateNumber;
        data["flightStatus"] = this.flightStatus;
        data["flightStatusId"] = this.flightStatusId;
        data["terminal"] = this.terminal;
        data["flightDate"] = this.flightDate;
        data["airportName"] = this.airportName;
        data["airportIataCode"] = this.airportIataCode;
        data["airportIcaoCode"] = this.airportIcaoCode;
        data["liveUrl"] = this.liveUrl;
        data["lastUpdateTime"] = this.lastUpdateTime;
        data["live"] = this.live;
        return data;
    }
}

export interface IFlight {
    flightId?: string | undefined;
    type?: string | undefined;
    flightCode?: string | undefined;
    callSign?: string | undefined;
    airlineName?: string | undefined;
    airlineCode?: string | undefined;
    airlineImgUrl?: string | undefined;
    fromOrTo?: string | undefined;
    fromOrToIataCode?: string | undefined;
    scheduledTime?: string | undefined;
    estimatedTime?: string | undefined;
    exactTime?: string | undefined;
    gateNumber?: number | undefined;
    flightStatus?: string | undefined;
    flightStatusId?: number | undefined;
    terminal?: string | undefined;
    flightDate?: string | undefined;
    airportName?: string | undefined;
    airportIataCode?: string | undefined;
    airportIcaoCode?: string | undefined;
    liveUrl?: string | undefined;
    lastUpdateTime?: string | undefined;
    live?: boolean;
}

export class Geometry implements IGeometry {
    factory?: GeometryFactory;
    userData?: any | undefined;
    srid?: number;
    readonly geometryType?: string | undefined;
    ogcGeometryType?: OgcGeometryType;
    precisionModel?: PrecisionModel;
    coordinate?: Coordinate;
    readonly coordinates?: Coordinate[] | undefined;
    readonly numPoints?: number;
    readonly numGeometries?: number;
    readonly isSimple?: boolean;
    readonly isValid?: boolean;
    readonly isEmpty?: boolean;
    readonly area?: number;
    readonly length?: number;
    centroid?: Point;
    interiorPoint?: Point;
    pointOnSurface?: Point;
    dimension?: Dimension;
    boundary?: Geometry;
    boundaryDimension?: Dimension;
    envelope?: Geometry;
    envelopeInternal?: Envelope;
    readonly isRectangle?: boolean;

    constructor(data?: IGeometry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.factory = _data["factory"] ? GeometryFactory.fromJS(_data["factory"]) : <any>undefined;
            this.userData = _data["userData"];
            this.srid = _data["srid"];
            (<any>this).geometryType = _data["geometryType"];
            this.ogcGeometryType = _data["ogcGeometryType"];
            this.precisionModel = _data["precisionModel"] ? PrecisionModel.fromJS(_data["precisionModel"]) : <any>undefined;
            this.coordinate = _data["coordinate"] ? Coordinate.fromJS(_data["coordinate"]) : <any>undefined;
            if (Array.isArray(_data["coordinates"])) {
                (<any>this).coordinates = [] as any;
                for (let item of _data["coordinates"])
                    (<any>this).coordinates!.push(Coordinate.fromJS(item));
            }
            (<any>this).numPoints = _data["numPoints"];
            (<any>this).numGeometries = _data["numGeometries"];
            (<any>this).isSimple = _data["isSimple"];
            (<any>this).isValid = _data["isValid"];
            (<any>this).isEmpty = _data["isEmpty"];
            (<any>this).area = _data["area"];
            (<any>this).length = _data["length"];
            this.centroid = _data["centroid"] ? Point.fromJS(_data["centroid"]) : <any>undefined;
            this.interiorPoint = _data["interiorPoint"] ? Point.fromJS(_data["interiorPoint"]) : <any>undefined;
            this.pointOnSurface = _data["pointOnSurface"] ? Point.fromJS(_data["pointOnSurface"]) : <any>undefined;
            this.dimension = _data["dimension"];
            this.boundary = _data["boundary"] ? Geometry.fromJS(_data["boundary"]) : <any>undefined;
            this.boundaryDimension = _data["boundaryDimension"];
            this.envelope = _data["envelope"] ? Geometry.fromJS(_data["envelope"]) : <any>undefined;
            this.envelopeInternal = _data["envelopeInternal"] ? Envelope.fromJS(_data["envelopeInternal"]) : <any>undefined;
            (<any>this).isRectangle = _data["isRectangle"];
        }
    }

    static fromJS(data: any): Geometry {
        data = typeof data === 'object' ? data : {};
        let result = new Geometry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["factory"] = this.factory ? this.factory.toJSON() : <any>undefined;
        data["userData"] = this.userData;
        data["srid"] = this.srid;
        data["geometryType"] = this.geometryType;
        data["ogcGeometryType"] = this.ogcGeometryType;
        data["precisionModel"] = this.precisionModel ? this.precisionModel.toJSON() : <any>undefined;
        data["coordinate"] = this.coordinate ? this.coordinate.toJSON() : <any>undefined;
        if (Array.isArray(this.coordinates)) {
            data["coordinates"] = [];
            for (let item of this.coordinates)
                data["coordinates"].push(item.toJSON());
        }
        data["numPoints"] = this.numPoints;
        data["numGeometries"] = this.numGeometries;
        data["isSimple"] = this.isSimple;
        data["isValid"] = this.isValid;
        data["isEmpty"] = this.isEmpty;
        data["area"] = this.area;
        data["length"] = this.length;
        data["centroid"] = this.centroid ? this.centroid.toJSON() : <any>undefined;
        data["interiorPoint"] = this.interiorPoint ? this.interiorPoint.toJSON() : <any>undefined;
        data["pointOnSurface"] = this.pointOnSurface ? this.pointOnSurface.toJSON() : <any>undefined;
        data["dimension"] = this.dimension;
        data["boundary"] = this.boundary ? this.boundary.toJSON() : <any>undefined;
        data["boundaryDimension"] = this.boundaryDimension;
        data["envelope"] = this.envelope ? this.envelope.toJSON() : <any>undefined;
        data["envelopeInternal"] = this.envelopeInternal ? this.envelopeInternal.toJSON() : <any>undefined;
        data["isRectangle"] = this.isRectangle;
        return data;
    }
}

export interface IGeometry {
    factory?: GeometryFactory;
    userData?: any | undefined;
    srid?: number;
    geometryType?: string | undefined;
    ogcGeometryType?: OgcGeometryType;
    precisionModel?: PrecisionModel;
    coordinate?: Coordinate;
    coordinates?: Coordinate[] | undefined;
    numPoints?: number;
    numGeometries?: number;
    isSimple?: boolean;
    isValid?: boolean;
    isEmpty?: boolean;
    area?: number;
    length?: number;
    centroid?: Point;
    interiorPoint?: Point;
    pointOnSurface?: Point;
    dimension?: Dimension;
    boundary?: Geometry;
    boundaryDimension?: Dimension;
    envelope?: Geometry;
    envelopeInternal?: Envelope;
    isRectangle?: boolean;
}

export class GeometryFactory implements IGeometryFactory {
    precisionModel?: PrecisionModel;
    coordinateSequenceFactory?: CoordinateSequenceFactory;
    readonly srid?: number;

    constructor(data?: IGeometryFactory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.precisionModel = _data["precisionModel"] ? PrecisionModel.fromJS(_data["precisionModel"]) : <any>undefined;
            this.coordinateSequenceFactory = _data["coordinateSequenceFactory"] ? CoordinateSequenceFactory.fromJS(_data["coordinateSequenceFactory"]) : <any>undefined;
            (<any>this).srid = _data["srid"];
        }
    }

    static fromJS(data: any): GeometryFactory {
        data = typeof data === 'object' ? data : {};
        let result = new GeometryFactory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["precisionModel"] = this.precisionModel ? this.precisionModel.toJSON() : <any>undefined;
        data["coordinateSequenceFactory"] = this.coordinateSequenceFactory ? this.coordinateSequenceFactory.toJSON() : <any>undefined;
        data["srid"] = this.srid;
        return data;
    }
}

export interface IGeometryFactory {
    precisionModel?: PrecisionModel;
    coordinateSequenceFactory?: CoordinateSequenceFactory;
    srid?: number;
}

export class Incident implements IIncident {
    id?: string;
    incidentTypeId?: string;
    incidentType?: IncidentType;
    descriptionId?: string;
    description?: TextContent;
    cityCode?: number;
    countyCode?: number;
    neighborhoodCode?: number;
    startTime?: Date;
    endTime?: Date;
    lat?: number;
    lon?: number;
    city?: City;
    county?: County;
    neighborhood?: Neighborhood;

    constructor(data?: IIncident) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.incidentTypeId = _data["incidentTypeId"];
            this.incidentType = _data["incidentType"] ? IncidentType.fromJS(_data["incidentType"]) : <any>undefined;
            this.descriptionId = _data["descriptionId"];
            this.description = _data["description"] ? TextContent.fromJS(_data["description"]) : <any>undefined;
            this.cityCode = _data["cityCode"];
            this.countyCode = _data["countyCode"];
            this.neighborhoodCode = _data["neighborhoodCode"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.lat = _data["lat"];
            this.lon = _data["lon"];
            this.city = _data["city"] ? City.fromJS(_data["city"]) : <any>undefined;
            this.county = _data["county"] ? County.fromJS(_data["county"]) : <any>undefined;
            this.neighborhood = _data["neighborhood"] ? Neighborhood.fromJS(_data["neighborhood"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Incident {
        data = typeof data === 'object' ? data : {};
        let result = new Incident();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["incidentTypeId"] = this.incidentTypeId;
        data["incidentType"] = this.incidentType ? this.incidentType.toJSON() : <any>undefined;
        data["descriptionId"] = this.descriptionId;
        data["description"] = this.description ? this.description.toJSON() : <any>undefined;
        data["cityCode"] = this.cityCode;
        data["countyCode"] = this.countyCode;
        data["neighborhoodCode"] = this.neighborhoodCode;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["lat"] = this.lat;
        data["lon"] = this.lon;
        data["city"] = this.city ? this.city.toJSON() : <any>undefined;
        data["county"] = this.county ? this.county.toJSON() : <any>undefined;
        data["neighborhood"] = this.neighborhood ? this.neighborhood.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIncident {
    id?: string;
    incidentTypeId?: string;
    incidentType?: IncidentType;
    descriptionId?: string;
    description?: TextContent;
    cityCode?: number;
    countyCode?: number;
    neighborhoodCode?: number;
    startTime?: Date;
    endTime?: Date;
    lat?: number;
    lon?: number;
    city?: City;
    county?: County;
    neighborhood?: Neighborhood;
}

export class IncidentAddRequest implements IIncidentAddRequest {
    incidentTypeId?: string;
    description?: string | undefined;
    cityCode?: number;
    countyCode?: number;
    neighborhoodCode?: number;
    startTime?: Date;
    endTime?: Date;
    lat?: number;
    lon?: number;

    constructor(data?: IIncidentAddRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.incidentTypeId = _data["incidentTypeId"];
            this.description = _data["description"];
            this.cityCode = _data["cityCode"];
            this.countyCode = _data["countyCode"];
            this.neighborhoodCode = _data["neighborhoodCode"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.lat = _data["lat"];
            this.lon = _data["lon"];
        }
    }

    static fromJS(data: any): IncidentAddRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentAddRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incidentTypeId"] = this.incidentTypeId;
        data["description"] = this.description;
        data["cityCode"] = this.cityCode;
        data["countyCode"] = this.countyCode;
        data["neighborhoodCode"] = this.neighborhoodCode;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["lat"] = this.lat;
        data["lon"] = this.lon;
        return data;
    }
}

export interface IIncidentAddRequest {
    incidentTypeId?: string;
    description?: string | undefined;
    cityCode?: number;
    countyCode?: number;
    neighborhoodCode?: number;
    startTime?: Date;
    endTime?: Date;
    lat?: number;
    lon?: number;
}

export class IncidentBaseResponse implements IIncidentBaseResponse {
    data?: Incident;

    constructor(data?: IIncidentBaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? Incident.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IncidentBaseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentBaseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIncidentBaseResponse {
    data?: Incident;
}

export class IncidentDto implements IIncidentDto {
    id?: string;
    incidentType?: IncidentTypeDto;
    description?: string | undefined;
    cityCode?: number;
    countyCode?: number;
    countyName?: string | undefined;
    neighborhoodCode?: number;
    neighborhoodName?: string | undefined;
    startTime?: Date;
    endTime?: Date;
    lat?: number;
    lon?: number;

    constructor(data?: IIncidentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.incidentType = _data["incidentType"] ? IncidentTypeDto.fromJS(_data["incidentType"]) : <any>undefined;
            this.description = _data["description"];
            this.cityCode = _data["cityCode"];
            this.countyCode = _data["countyCode"];
            this.countyName = _data["countyName"];
            this.neighborhoodCode = _data["neighborhoodCode"];
            this.neighborhoodName = _data["neighborhoodName"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.lat = _data["lat"];
            this.lon = _data["lon"];
        }
    }

    static fromJS(data: any): IncidentDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["incidentType"] = this.incidentType ? this.incidentType.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["cityCode"] = this.cityCode;
        data["countyCode"] = this.countyCode;
        data["countyName"] = this.countyName;
        data["neighborhoodCode"] = this.neighborhoodCode;
        data["neighborhoodName"] = this.neighborhoodName;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["lat"] = this.lat;
        data["lon"] = this.lon;
        return data;
    }
}

export interface IIncidentDto {
    id?: string;
    incidentType?: IncidentTypeDto;
    description?: string | undefined;
    cityCode?: number;
    countyCode?: number;
    countyName?: string | undefined;
    neighborhoodCode?: number;
    neighborhoodName?: string | undefined;
    startTime?: Date;
    endTime?: Date;
    lat?: number;
    lon?: number;
}

export class IncidentDtoPageableResponse implements IIncidentDtoPageableResponse {
    currentPageNumber?: number;
    pageItemCount?: number;
    totalCount?: number;
    data?: IncidentDto[] | undefined;

    constructor(data?: IIncidentDtoPageableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPageNumber = _data["currentPageNumber"];
            this.pageItemCount = _data["pageItemCount"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(IncidentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IncidentDtoPageableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentDtoPageableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPageNumber"] = this.currentPageNumber;
        data["pageItemCount"] = this.pageItemCount;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIncidentDtoPageableResponse {
    currentPageNumber?: number;
    pageItemCount?: number;
    totalCount?: number;
    data?: IncidentDto[] | undefined;
}

export class IncidentSearchCriteria implements IIncidentSearchCriteria {
    cityCode?: number | undefined;
    countyCode?: number | undefined;
    incidentTypeIds?: string[] | undefined;
    fetchAfter?: Date | undefined;

    constructor(data?: IIncidentSearchCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cityCode = _data["cityCode"];
            this.countyCode = _data["countyCode"];
            if (Array.isArray(_data["incidentTypeIds"])) {
                this.incidentTypeIds = [] as any;
                for (let item of _data["incidentTypeIds"])
                    this.incidentTypeIds!.push(item);
            }
            this.fetchAfter = _data["fetchAfter"] ? new Date(_data["fetchAfter"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): IncidentSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentSearchCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cityCode"] = this.cityCode;
        data["countyCode"] = this.countyCode;
        if (Array.isArray(this.incidentTypeIds)) {
            data["incidentTypeIds"] = [];
            for (let item of this.incidentTypeIds)
                data["incidentTypeIds"].push(item);
        }
        data["fetchAfter"] = this.fetchAfter ? this.fetchAfter.toISOString() : <any>undefined;
        return data;
    }
}

export interface IIncidentSearchCriteria {
    cityCode?: number | undefined;
    countyCode?: number | undefined;
    incidentTypeIds?: string[] | undefined;
    fetchAfter?: Date | undefined;
}

export class IncidentSearchCriteriaPageableSearch implements IIncidentSearchCriteriaPageableSearch {
    pageNumber?: number;
    pageSize?: number;
    sortField?: string | undefined;
    sortOrder?: number | undefined;
    searchCriteria?: IncidentSearchCriteria;

    constructor(data?: IIncidentSearchCriteriaPageableSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortOrder = _data["sortOrder"];
            this.searchCriteria = _data["searchCriteria"] ? IncidentSearchCriteria.fromJS(_data["searchCriteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IncidentSearchCriteriaPageableSearch {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentSearchCriteriaPageableSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortOrder"] = this.sortOrder;
        data["searchCriteria"] = this.searchCriteria ? this.searchCriteria.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIncidentSearchCriteriaPageableSearch {
    pageNumber?: number;
    pageSize?: number;
    sortField?: string | undefined;
    sortOrder?: number | undefined;
    searchCriteria?: IncidentSearchCriteria;
}

export class IncidentType implements IIncidentType {
    id?: string;
    textContentId?: string;
    iconUrl?: string | undefined;
    textContent?: TextContent;

    constructor(data?: IIncidentType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.textContentId = _data["textContentId"];
            this.iconUrl = _data["iconUrl"];
            this.textContent = _data["textContent"] ? TextContent.fromJS(_data["textContent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IncidentType {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["textContentId"] = this.textContentId;
        data["iconUrl"] = this.iconUrl;
        data["textContent"] = this.textContent ? this.textContent.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIncidentType {
    id?: string;
    textContentId?: string;
    iconUrl?: string | undefined;
    textContent?: TextContent;
}

export class IncidentTypeDto implements IIncidentTypeDto {
    id?: string;
    name?: string | undefined;
    iconUrl?: string | undefined;

    constructor(data?: IIncidentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.iconUrl = _data["iconUrl"];
        }
    }

    static fromJS(data: any): IncidentTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["iconUrl"] = this.iconUrl;
        return data;
    }
}

export interface IIncidentTypeDto {
    id?: string;
    name?: string | undefined;
    iconUrl?: string | undefined;
}

export class IncidentTypeDtoBaseResponse implements IIncidentTypeDtoBaseResponse {
    data?: IncidentTypeDto;

    constructor(data?: IIncidentTypeDtoBaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? IncidentTypeDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IncidentTypeDtoBaseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentTypeDtoBaseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIncidentTypeDtoBaseResponse {
    data?: IncidentTypeDto;
}

export class IncidentTypeDtoListBaseResponse implements IIncidentTypeDtoListBaseResponse {
    data?: IncidentTypeDto[] | undefined;

    constructor(data?: IIncidentTypeDtoListBaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(IncidentTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IncidentTypeDtoListBaseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentTypeDtoListBaseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIncidentTypeDtoListBaseResponse {
    data?: IncidentTypeDto[] | undefined;
}

export class IncidentUpdateRequest implements IIncidentUpdateRequest {
    incidentId?: string;
    description?: string | undefined;
    startTime?: Date;
    endTime?: Date;
    lat?: number;
    lon?: number;

    constructor(data?: IIncidentUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.incidentId = _data["incidentId"];
            this.description = _data["description"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.lat = _data["lat"];
            this.lon = _data["lon"];
        }
    }

    static fromJS(data: any): IncidentUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incidentId"] = this.incidentId;
        data["description"] = this.description;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["lat"] = this.lat;
        data["lon"] = this.lon;
        return data;
    }
}

export interface IIncidentUpdateRequest {
    incidentId?: string;
    description?: string | undefined;
    startTime?: Date;
    endTime?: Date;
    lat?: number;
    lon?: number;
}

export class Issue implements IIssue {
    id?: string;
    issueCategoryId?: string;
    issueCityCode?: number;
    status?: IssueStatus;
    creationDateTime?: Date;
    doneDateTime?: Date | undefined;
    creatorDeviceId?: string | undefined;
    creatorName?: string | undefined;
    creatorLastName?: string | undefined;
    creatorPhone?: string | undefined;
    creatorEmail?: string | undefined;
    issueSubject?: string | undefined;
    issueDescription?: string | undefined;
    operatorId?: string | undefined;
    operatorReply?: string | undefined;
    lat?: number | undefined;
    lon?: number | undefined;
    issueAssets?: IssueAsset[] | undefined;
    city?: City;
    issueCategory?: IssueCategory;

    constructor(data?: IIssue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.issueCategoryId = _data["issueCategoryId"];
            this.issueCityCode = _data["issueCityCode"];
            this.status = _data["status"];
            this.creationDateTime = _data["creationDateTime"] ? new Date(_data["creationDateTime"].toString()) : <any>undefined;
            this.doneDateTime = _data["doneDateTime"] ? new Date(_data["doneDateTime"].toString()) : <any>undefined;
            this.creatorDeviceId = _data["creatorDeviceId"];
            this.creatorName = _data["creatorName"];
            this.creatorLastName = _data["creatorLastName"];
            this.creatorPhone = _data["creatorPhone"];
            this.creatorEmail = _data["creatorEmail"];
            this.issueSubject = _data["issueSubject"];
            this.issueDescription = _data["issueDescription"];
            this.operatorId = _data["operatorId"];
            this.operatorReply = _data["operatorReply"];
            this.lat = _data["lat"];
            this.lon = _data["lon"];
            if (Array.isArray(_data["issueAssets"])) {
                this.issueAssets = [] as any;
                for (let item of _data["issueAssets"])
                    this.issueAssets!.push(IssueAsset.fromJS(item));
            }
            this.city = _data["city"] ? City.fromJS(_data["city"]) : <any>undefined;
            this.issueCategory = _data["issueCategory"] ? IssueCategory.fromJS(_data["issueCategory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Issue {
        data = typeof data === 'object' ? data : {};
        let result = new Issue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["issueCategoryId"] = this.issueCategoryId;
        data["issueCityCode"] = this.issueCityCode;
        data["status"] = this.status;
        data["creationDateTime"] = this.creationDateTime ? this.creationDateTime.toISOString() : <any>undefined;
        data["doneDateTime"] = this.doneDateTime ? this.doneDateTime.toISOString() : <any>undefined;
        data["creatorDeviceId"] = this.creatorDeviceId;
        data["creatorName"] = this.creatorName;
        data["creatorLastName"] = this.creatorLastName;
        data["creatorPhone"] = this.creatorPhone;
        data["creatorEmail"] = this.creatorEmail;
        data["issueSubject"] = this.issueSubject;
        data["issueDescription"] = this.issueDescription;
        data["operatorId"] = this.operatorId;
        data["operatorReply"] = this.operatorReply;
        data["lat"] = this.lat;
        data["lon"] = this.lon;
        if (Array.isArray(this.issueAssets)) {
            data["issueAssets"] = [];
            for (let item of this.issueAssets)
                data["issueAssets"].push(item.toJSON());
        }
        data["city"] = this.city ? this.city.toJSON() : <any>undefined;
        data["issueCategory"] = this.issueCategory ? this.issueCategory.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIssue {
    id?: string;
    issueCategoryId?: string;
    issueCityCode?: number;
    status?: IssueStatus;
    creationDateTime?: Date;
    doneDateTime?: Date | undefined;
    creatorDeviceId?: string | undefined;
    creatorName?: string | undefined;
    creatorLastName?: string | undefined;
    creatorPhone?: string | undefined;
    creatorEmail?: string | undefined;
    issueSubject?: string | undefined;
    issueDescription?: string | undefined;
    operatorId?: string | undefined;
    operatorReply?: string | undefined;
    lat?: number | undefined;
    lon?: number | undefined;
    issueAssets?: IssueAsset[] | undefined;
    city?: City;
    issueCategory?: IssueCategory;
}

export class IssueAddRequest implements IIssueAddRequest {
    issueCategoryId?: string;
    issueCityCode?: number;
    creatorDeviceId?: string | undefined;
    creatorName?: string | undefined;
    creatorLastName?: string | undefined;
    creatorPhone?: string | undefined;
    creatorEmail?: string | undefined;
    issueSubject?: string | undefined;
    issueDescription?: string | undefined;
    lat?: number | undefined;
    lon?: number | undefined;

    constructor(data?: IIssueAddRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueCategoryId = _data["issueCategoryId"];
            this.issueCityCode = _data["issueCityCode"];
            this.creatorDeviceId = _data["creatorDeviceId"];
            this.creatorName = _data["creatorName"];
            this.creatorLastName = _data["creatorLastName"];
            this.creatorPhone = _data["creatorPhone"];
            this.creatorEmail = _data["creatorEmail"];
            this.issueSubject = _data["issueSubject"];
            this.issueDescription = _data["issueDescription"];
            this.lat = _data["lat"];
            this.lon = _data["lon"];
        }
    }

    static fromJS(data: any): IssueAddRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IssueAddRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueCategoryId"] = this.issueCategoryId;
        data["issueCityCode"] = this.issueCityCode;
        data["creatorDeviceId"] = this.creatorDeviceId;
        data["creatorName"] = this.creatorName;
        data["creatorLastName"] = this.creatorLastName;
        data["creatorPhone"] = this.creatorPhone;
        data["creatorEmail"] = this.creatorEmail;
        data["issueSubject"] = this.issueSubject;
        data["issueDescription"] = this.issueDescription;
        data["lat"] = this.lat;
        data["lon"] = this.lon;
        return data;
    }
}

export interface IIssueAddRequest {
    issueCategoryId?: string;
    issueCityCode?: number;
    creatorDeviceId?: string | undefined;
    creatorName?: string | undefined;
    creatorLastName?: string | undefined;
    creatorPhone?: string | undefined;
    creatorEmail?: string | undefined;
    issueSubject?: string | undefined;
    issueDescription?: string | undefined;
    lat?: number | undefined;
    lon?: number | undefined;
}

export class IssueAsset implements IIssueAsset {
    id?: string;
    issueId?: string;
    photoUrl?: string | undefined;
    issue?: Issue;

    constructor(data?: IIssueAsset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.issueId = _data["issueId"];
            this.photoUrl = _data["photoUrl"];
            this.issue = _data["issue"] ? Issue.fromJS(_data["issue"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IssueAsset {
        data = typeof data === 'object' ? data : {};
        let result = new IssueAsset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["issueId"] = this.issueId;
        data["photoUrl"] = this.photoUrl;
        data["issue"] = this.issue ? this.issue.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIssueAsset {
    id?: string;
    issueId?: string;
    photoUrl?: string | undefined;
    issue?: Issue;
}

export class IssueCategory implements IIssueCategory {
    id?: string;
    descriptionId?: string;
    description?: TextContent;
    cityCode?: number;
    city?: City;

    constructor(data?: IIssueCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.descriptionId = _data["descriptionId"];
            this.description = _data["description"] ? TextContent.fromJS(_data["description"]) : <any>undefined;
            this.cityCode = _data["cityCode"];
            this.city = _data["city"] ? City.fromJS(_data["city"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IssueCategory {
        data = typeof data === 'object' ? data : {};
        let result = new IssueCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["descriptionId"] = this.descriptionId;
        data["description"] = this.description ? this.description.toJSON() : <any>undefined;
        data["cityCode"] = this.cityCode;
        data["city"] = this.city ? this.city.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIssueCategory {
    id?: string;
    descriptionId?: string;
    description?: TextContent;
    cityCode?: number;
    city?: City;
}

export class IssueCategoryDto implements IIssueCategoryDto {
    id?: string;
    name?: string | undefined;
    cityCode?: number;

    constructor(data?: IIssueCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.cityCode = _data["cityCode"];
        }
    }

    static fromJS(data: any): IssueCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new IssueCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["cityCode"] = this.cityCode;
        return data;
    }
}

export interface IIssueCategoryDto {
    id?: string;
    name?: string | undefined;
    cityCode?: number;
}

export class IssueCategoryDtoBaseResponse implements IIssueCategoryDtoBaseResponse {
    data?: IssueCategoryDto;

    constructor(data?: IIssueCategoryDtoBaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? IssueCategoryDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IssueCategoryDtoBaseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IssueCategoryDtoBaseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIssueCategoryDtoBaseResponse {
    data?: IssueCategoryDto;
}

export class IssueCategoryDtoListBaseResponse implements IIssueCategoryDtoListBaseResponse {
    data?: IssueCategoryDto[] | undefined;

    constructor(data?: IIssueCategoryDtoListBaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(IssueCategoryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IssueCategoryDtoListBaseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IssueCategoryDtoListBaseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIssueCategoryDtoListBaseResponse {
    data?: IssueCategoryDto[] | undefined;
}

export class IssuePageableResponse implements IIssuePageableResponse {
    currentPageNumber?: number;
    pageItemCount?: number;
    totalCount?: number;
    data?: Issue[] | undefined;

    constructor(data?: IIssuePageableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPageNumber = _data["currentPageNumber"];
            this.pageItemCount = _data["pageItemCount"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Issue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IssuePageableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IssuePageableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPageNumber"] = this.currentPageNumber;
        data["pageItemCount"] = this.pageItemCount;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIssuePageableResponse {
    currentPageNumber?: number;
    pageItemCount?: number;
    totalCount?: number;
    data?: Issue[] | undefined;
}

export class IssueSearchCriteria implements IIssueSearchCriteria {
    cityCode?: number | undefined;
    issueCategoryIds?: string[] | undefined;
    statusList?: IssueStatus[] | undefined;
    creatorDeviceId?: string | undefined;
    fetchAfter?: Date | undefined;

    constructor(data?: IIssueSearchCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cityCode = _data["cityCode"];
            if (Array.isArray(_data["issueCategoryIds"])) {
                this.issueCategoryIds = [] as any;
                for (let item of _data["issueCategoryIds"])
                    this.issueCategoryIds!.push(item);
            }
            if (Array.isArray(_data["statusList"])) {
                this.statusList = [] as any;
                for (let item of _data["statusList"])
                    this.statusList!.push(item);
            }
            this.creatorDeviceId = _data["creatorDeviceId"];
            this.fetchAfter = _data["fetchAfter"] ? new Date(_data["fetchAfter"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): IssueSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new IssueSearchCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cityCode"] = this.cityCode;
        if (Array.isArray(this.issueCategoryIds)) {
            data["issueCategoryIds"] = [];
            for (let item of this.issueCategoryIds)
                data["issueCategoryIds"].push(item);
        }
        if (Array.isArray(this.statusList)) {
            data["statusList"] = [];
            for (let item of this.statusList)
                data["statusList"].push(item);
        }
        data["creatorDeviceId"] = this.creatorDeviceId;
        data["fetchAfter"] = this.fetchAfter ? this.fetchAfter.toISOString() : <any>undefined;
        return data;
    }
}

export interface IIssueSearchCriteria {
    cityCode?: number | undefined;
    issueCategoryIds?: string[] | undefined;
    statusList?: IssueStatus[] | undefined;
    creatorDeviceId?: string | undefined;
    fetchAfter?: Date | undefined;
}

export class IssueSearchCriteriaPageableSearch implements IIssueSearchCriteriaPageableSearch {
    pageNumber?: number;
    pageSize?: number;
    sortField?: string | undefined;
    sortOrder?: number | undefined;
    searchCriteria?: IssueSearchCriteria;

    constructor(data?: IIssueSearchCriteriaPageableSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortOrder = _data["sortOrder"];
            this.searchCriteria = _data["searchCriteria"] ? IssueSearchCriteria.fromJS(_data["searchCriteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IssueSearchCriteriaPageableSearch {
        data = typeof data === 'object' ? data : {};
        let result = new IssueSearchCriteriaPageableSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortOrder"] = this.sortOrder;
        data["searchCriteria"] = this.searchCriteria ? this.searchCriteria.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIssueSearchCriteriaPageableSearch {
    pageNumber?: number;
    pageSize?: number;
    sortField?: string | undefined;
    sortOrder?: number | undefined;
    searchCriteria?: IssueSearchCriteria;
}

export enum IssueStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class IssueUpdateRequest implements IIssueUpdateRequest {
    issueId?: string;
    operatorReply?: string | undefined;
    status?: IssueStatus;

    constructor(data?: IIssueUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"];
            this.operatorReply = _data["operatorReply"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): IssueUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IssueUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId;
        data["operatorReply"] = this.operatorReply;
        data["status"] = this.status;
        return data;
    }
}

export interface IIssueUpdateRequest {
    issueId?: string;
    operatorReply?: string | undefined;
    status?: IssueStatus;
}

export class Language implements ILanguage {
    langCode?: string | undefined;
    description?: string | undefined;

    constructor(data?: ILanguage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.langCode = _data["langCode"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): Language {
        data = typeof data === 'object' ? data : {};
        let result = new Language();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["langCode"] = this.langCode;
        data["description"] = this.description;
        return data;
    }
}

export interface ILanguage {
    langCode?: string | undefined;
    description?: string | undefined;
}

export class Mayor implements IMayor {
    id?: string;
    cvContentId?: string;
    name?: string | undefined;
    cityCode?: number;
    cvContent?: TextContent;
    lastModified?: Date;
    operatorId?: string | undefined;
    mayorPhoto?: MayorPhoto;

    constructor(data?: IMayor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cvContentId = _data["cvContentId"];
            this.name = _data["name"];
            this.cityCode = _data["cityCode"];
            this.cvContent = _data["cvContent"] ? TextContent.fromJS(_data["cvContent"]) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.operatorId = _data["operatorId"];
            this.mayorPhoto = _data["mayorPhoto"] ? MayorPhoto.fromJS(_data["mayorPhoto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Mayor {
        data = typeof data === 'object' ? data : {};
        let result = new Mayor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cvContentId"] = this.cvContentId;
        data["name"] = this.name;
        data["cityCode"] = this.cityCode;
        data["cvContent"] = this.cvContent ? this.cvContent.toJSON() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["operatorId"] = this.operatorId;
        data["mayorPhoto"] = this.mayorPhoto ? this.mayorPhoto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMayor {
    id?: string;
    cvContentId?: string;
    name?: string | undefined;
    cityCode?: number;
    cvContent?: TextContent;
    lastModified?: Date;
    operatorId?: string | undefined;
    mayorPhoto?: MayorPhoto;
}

export class MayorAddRequest implements IMayorAddRequest {
    name?: string | undefined;
    cvContent?: string | undefined;
    operatorId?: string | undefined;
    cityCode?: number;
    modificationDate?: Date;

    constructor(data?: IMayorAddRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.cvContent = _data["cvContent"];
            this.operatorId = _data["operatorId"];
            this.cityCode = _data["cityCode"];
            this.modificationDate = _data["modificationDate"] ? new Date(_data["modificationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MayorAddRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MayorAddRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["cvContent"] = this.cvContent;
        data["operatorId"] = this.operatorId;
        data["cityCode"] = this.cityCode;
        data["modificationDate"] = this.modificationDate ? this.modificationDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMayorAddRequest {
    name?: string | undefined;
    cvContent?: string | undefined;
    operatorId?: string | undefined;
    cityCode?: number;
    modificationDate?: Date;
}

export class MayorPhoto implements IMayorPhoto {
    id?: string;
    mayorId?: string;
    cityCode?: number;
    assetUrl?: string | undefined;
    modifiedDate?: Date;
    modifiedOperator?: string;

    constructor(data?: IMayorPhoto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mayorId = _data["mayorId"];
            this.cityCode = _data["cityCode"];
            this.assetUrl = _data["assetUrl"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.modifiedOperator = _data["modifiedOperator"];
        }
    }

    static fromJS(data: any): MayorPhoto {
        data = typeof data === 'object' ? data : {};
        let result = new MayorPhoto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mayorId"] = this.mayorId;
        data["cityCode"] = this.cityCode;
        data["assetUrl"] = this.assetUrl;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["modifiedOperator"] = this.modifiedOperator;
        return data;
    }
}

export interface IMayorPhoto {
    id?: string;
    mayorId?: string;
    cityCode?: number;
    assetUrl?: string | undefined;
    modifiedDate?: Date;
    modifiedOperator?: string;
}

export class MayorUpdateRequest implements IMayorUpdateRequest {
    name?: string | undefined;
    cvContent?: string | undefined;
    operatorId?: string | undefined;
    cityCode?: number;
    modificationDate?: Date;

    constructor(data?: IMayorUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.cvContent = _data["cvContent"];
            this.operatorId = _data["operatorId"];
            this.cityCode = _data["cityCode"];
            this.modificationDate = _data["modificationDate"] ? new Date(_data["modificationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MayorUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MayorUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["cvContent"] = this.cvContent;
        data["operatorId"] = this.operatorId;
        data["cityCode"] = this.cityCode;
        data["modificationDate"] = this.modificationDate ? this.modificationDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMayorUpdateRequest {
    name?: string | undefined;
    cvContent?: string | undefined;
    operatorId?: string | undefined;
    cityCode?: number;
    modificationDate?: Date;
}

export class Neighborhood implements INeighborhood {
    code?: number;
    name?: string | undefined;
    lat?: number;
    lon?: number;
    cityCode?: number;
    city?: City;
    countyCode?: number;
    county?: County;
    places?: Place[] | undefined;

    constructor(data?: INeighborhood) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.lat = _data["lat"];
            this.lon = _data["lon"];
            this.cityCode = _data["cityCode"];
            this.city = _data["city"] ? City.fromJS(_data["city"]) : <any>undefined;
            this.countyCode = _data["countyCode"];
            this.county = _data["county"] ? County.fromJS(_data["county"]) : <any>undefined;
            if (Array.isArray(_data["places"])) {
                this.places = [] as any;
                for (let item of _data["places"])
                    this.places!.push(Place.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Neighborhood {
        data = typeof data === 'object' ? data : {};
        let result = new Neighborhood();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["lat"] = this.lat;
        data["lon"] = this.lon;
        data["cityCode"] = this.cityCode;
        data["city"] = this.city ? this.city.toJSON() : <any>undefined;
        data["countyCode"] = this.countyCode;
        data["county"] = this.county ? this.county.toJSON() : <any>undefined;
        if (Array.isArray(this.places)) {
            data["places"] = [];
            for (let item of this.places)
                data["places"].push(item.toJSON());
        }
        return data;
    }
}

export interface INeighborhood {
    code?: number;
    name?: string | undefined;
    lat?: number;
    lon?: number;
    cityCode?: number;
    city?: City;
    countyCode?: number;
    county?: County;
    places?: Place[] | undefined;
}

export class NeighborhoodAddRequest implements INeighborhoodAddRequest {
    code?: number;
    name?: string | undefined;
    lat?: number;
    lon?: number;
    cityCode?: number;
    countyCode?: number;

    constructor(data?: INeighborhoodAddRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.lat = _data["lat"];
            this.lon = _data["lon"];
            this.cityCode = _data["cityCode"];
            this.countyCode = _data["countyCode"];
        }
    }

    static fromJS(data: any): NeighborhoodAddRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NeighborhoodAddRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["lat"] = this.lat;
        data["lon"] = this.lon;
        data["cityCode"] = this.cityCode;
        data["countyCode"] = this.countyCode;
        return data;
    }
}

export interface INeighborhoodAddRequest {
    code?: number;
    name?: string | undefined;
    lat?: number;
    lon?: number;
    cityCode?: number;
    countyCode?: number;
}

export class NeighborhoodBaseResponse implements INeighborhoodBaseResponse {
    data?: Neighborhood;

    constructor(data?: INeighborhoodBaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? Neighborhood.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NeighborhoodBaseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NeighborhoodBaseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface INeighborhoodBaseResponse {
    data?: Neighborhood;
}

export class NeighborhoodPageableResponse implements INeighborhoodPageableResponse {
    currentPageNumber?: number;
    pageItemCount?: number;
    totalCount?: number;
    data?: Neighborhood[] | undefined;

    constructor(data?: INeighborhoodPageableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPageNumber = _data["currentPageNumber"];
            this.pageItemCount = _data["pageItemCount"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Neighborhood.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NeighborhoodPageableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NeighborhoodPageableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPageNumber"] = this.currentPageNumber;
        data["pageItemCount"] = this.pageItemCount;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface INeighborhoodPageableResponse {
    currentPageNumber?: number;
    pageItemCount?: number;
    totalCount?: number;
    data?: Neighborhood[] | undefined;
}

export class NeighborhoodSearchCriteria implements INeighborhoodSearchCriteria {
    cityCode?: number | undefined;
    countyCode?: number | undefined;
    name?: string | undefined;

    constructor(data?: INeighborhoodSearchCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cityCode = _data["cityCode"];
            this.countyCode = _data["countyCode"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): NeighborhoodSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new NeighborhoodSearchCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cityCode"] = this.cityCode;
        data["countyCode"] = this.countyCode;
        data["name"] = this.name;
        return data;
    }
}

export interface INeighborhoodSearchCriteria {
    cityCode?: number | undefined;
    countyCode?: number | undefined;
    name?: string | undefined;
}

export class NeighborhoodSearchCriteriaPageableSearch implements INeighborhoodSearchCriteriaPageableSearch {
    pageNumber?: number;
    pageSize?: number;
    sortField?: string | undefined;
    sortOrder?: number | undefined;
    searchCriteria?: NeighborhoodSearchCriteria;

    constructor(data?: INeighborhoodSearchCriteriaPageableSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortOrder = _data["sortOrder"];
            this.searchCriteria = _data["searchCriteria"] ? NeighborhoodSearchCriteria.fromJS(_data["searchCriteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NeighborhoodSearchCriteriaPageableSearch {
        data = typeof data === 'object' ? data : {};
        let result = new NeighborhoodSearchCriteriaPageableSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortOrder"] = this.sortOrder;
        data["searchCriteria"] = this.searchCriteria ? this.searchCriteria.toJSON() : <any>undefined;
        return data;
    }
}

export interface INeighborhoodSearchCriteriaPageableSearch {
    pageNumber?: number;
    pageSize?: number;
    sortField?: string | undefined;
    sortOrder?: number | undefined;
    searchCriteria?: NeighborhoodSearchCriteria;
}

export class News implements INews {
    id?: string;
    titleContentId?: string;
    newsContentId?: string;
    date?: Date;
    cityCode?: number;
    isArchived?: boolean;
    newsAssets?: NewsAsset[] | undefined;
    titleContent?: TextContent;
    newsContent?: TextContent;

    constructor(data?: INews) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.titleContentId = _data["titleContentId"];
            this.newsContentId = _data["newsContentId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.cityCode = _data["cityCode"];
            this.isArchived = _data["isArchived"];
            if (Array.isArray(_data["newsAssets"])) {
                this.newsAssets = [] as any;
                for (let item of _data["newsAssets"])
                    this.newsAssets!.push(NewsAsset.fromJS(item));
            }
            this.titleContent = _data["titleContent"] ? TextContent.fromJS(_data["titleContent"]) : <any>undefined;
            this.newsContent = _data["newsContent"] ? TextContent.fromJS(_data["newsContent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): News {
        data = typeof data === 'object' ? data : {};
        let result = new News();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["titleContentId"] = this.titleContentId;
        data["newsContentId"] = this.newsContentId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["cityCode"] = this.cityCode;
        data["isArchived"] = this.isArchived;
        if (Array.isArray(this.newsAssets)) {
            data["newsAssets"] = [];
            for (let item of this.newsAssets)
                data["newsAssets"].push(item.toJSON());
        }
        data["titleContent"] = this.titleContent ? this.titleContent.toJSON() : <any>undefined;
        data["newsContent"] = this.newsContent ? this.newsContent.toJSON() : <any>undefined;
        return data;
    }
}

export interface INews {
    id?: string;
    titleContentId?: string;
    newsContentId?: string;
    date?: Date;
    cityCode?: number;
    isArchived?: boolean;
    newsAssets?: NewsAsset[] | undefined;
    titleContent?: TextContent;
    newsContent?: TextContent;
}

export class NewsAddRequest implements INewsAddRequest {
    cityCode?: number;
    title?: string | undefined;
    text?: string | undefined;
    date?: Date;

    constructor(data?: INewsAddRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cityCode = _data["cityCode"];
            this.title = _data["title"];
            this.text = _data["text"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NewsAddRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NewsAddRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cityCode"] = this.cityCode;
        data["title"] = this.title;
        data["text"] = this.text;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data;
    }
}

export interface INewsAddRequest {
    cityCode?: number;
    title?: string | undefined;
    text?: string | undefined;
    date?: Date;
}

export class NewsAsset implements INewsAsset {
    id?: string;
    newsId?: string;
    assetUrl?: string | undefined;
    news?: News;

    constructor(data?: INewsAsset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.newsId = _data["newsId"];
            this.assetUrl = _data["assetUrl"];
            this.news = _data["news"] ? News.fromJS(_data["news"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NewsAsset {
        data = typeof data === 'object' ? data : {};
        let result = new NewsAsset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newsId"] = this.newsId;
        data["assetUrl"] = this.assetUrl;
        data["news"] = this.news ? this.news.toJSON() : <any>undefined;
        return data;
    }
}

export interface INewsAsset {
    id?: string;
    newsId?: string;
    assetUrl?: string | undefined;
    news?: News;
}

export class NewsBaseResponse implements INewsBaseResponse {
    data?: News;

    constructor(data?: INewsBaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? News.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NewsBaseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NewsBaseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface INewsBaseResponse {
    data?: News;
}

export class NewsDTO implements INewsDTO {
    id?: string;
    cityCode?: number;
    title?: string | undefined;
    content?: string | undefined;
    date?: Date;
    isArchived?: boolean;
    assetList?: NewsAsset[] | undefined;

    constructor(data?: INewsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cityCode = _data["cityCode"];
            this.title = _data["title"];
            this.content = _data["content"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.isArchived = _data["isArchived"];
            if (Array.isArray(_data["assetList"])) {
                this.assetList = [] as any;
                for (let item of _data["assetList"])
                    this.assetList!.push(NewsAsset.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NewsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NewsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cityCode"] = this.cityCode;
        data["title"] = this.title;
        data["content"] = this.content;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["isArchived"] = this.isArchived;
        if (Array.isArray(this.assetList)) {
            data["assetList"] = [];
            for (let item of this.assetList)
                data["assetList"].push(item.toJSON());
        }
        return data;
    }
}

export interface INewsDTO {
    id?: string;
    cityCode?: number;
    title?: string | undefined;
    content?: string | undefined;
    date?: Date;
    isArchived?: boolean;
    assetList?: NewsAsset[] | undefined;
}

export class NewsDTOPageableResponse implements INewsDTOPageableResponse {
    currentPageNumber?: number;
    pageItemCount?: number;
    totalCount?: number;
    data?: NewsDTO[] | undefined;

    constructor(data?: INewsDTOPageableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPageNumber = _data["currentPageNumber"];
            this.pageItemCount = _data["pageItemCount"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(NewsDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NewsDTOPageableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NewsDTOPageableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPageNumber"] = this.currentPageNumber;
        data["pageItemCount"] = this.pageItemCount;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface INewsDTOPageableResponse {
    currentPageNumber?: number;
    pageItemCount?: number;
    totalCount?: number;
    data?: NewsDTO[] | undefined;
}

export class NewsSearchCriteria implements INewsSearchCriteria {
    cityCode?: number | undefined;
    title?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    isArchived?: boolean | undefined;

    constructor(data?: INewsSearchCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cityCode = _data["cityCode"];
            this.title = _data["title"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): NewsSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new NewsSearchCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cityCode"] = this.cityCode;
        data["title"] = this.title;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

export interface INewsSearchCriteria {
    cityCode?: number | undefined;
    title?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    isArchived?: boolean | undefined;
}

export class NewsSearchCriteriaPageableSearch implements INewsSearchCriteriaPageableSearch {
    pageNumber?: number;
    pageSize?: number;
    sortField?: string | undefined;
    sortOrder?: number | undefined;
    searchCriteria?: NewsSearchCriteria;

    constructor(data?: INewsSearchCriteriaPageableSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortOrder = _data["sortOrder"];
            this.searchCriteria = _data["searchCriteria"] ? NewsSearchCriteria.fromJS(_data["searchCriteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NewsSearchCriteriaPageableSearch {
        data = typeof data === 'object' ? data : {};
        let result = new NewsSearchCriteriaPageableSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortOrder"] = this.sortOrder;
        data["searchCriteria"] = this.searchCriteria ? this.searchCriteria.toJSON() : <any>undefined;
        return data;
    }
}

export interface INewsSearchCriteriaPageableSearch {
    pageNumber?: number;
    pageSize?: number;
    sortField?: string | undefined;
    sortOrder?: number | undefined;
    searchCriteria?: NewsSearchCriteria;
}

export class NewsUpdateRequest implements INewsUpdateRequest {
    cityCode?: number;
    title?: string | undefined;
    text?: string | undefined;
    date?: Date;
    id?: string;
    isArchived?: boolean;

    constructor(data?: INewsUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cityCode = _data["cityCode"];
            this.title = _data["title"];
            this.text = _data["text"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.id = _data["id"];
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): NewsUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NewsUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cityCode"] = this.cityCode;
        data["title"] = this.title;
        data["text"] = this.text;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

export interface INewsUpdateRequest {
    cityCode?: number;
    title?: string | undefined;
    text?: string | undefined;
    date?: Date;
    id?: string;
    isArchived?: boolean;
}

export class NotificationDto implements INotificationDto {
    contents?: string | undefined;
    headings?: string | undefined;
    sessionTime?: Date;
    id?: string | undefined;

    constructor(data?: INotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contents = _data["contents"];
            this.headings = _data["headings"];
            this.sessionTime = _data["sessionTime"] ? new Date(_data["sessionTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): NotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contents"] = this.contents;
        data["headings"] = this.headings;
        data["sessionTime"] = this.sessionTime ? this.sessionTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface INotificationDto {
    contents?: string | undefined;
    headings?: string | undefined;
    sessionTime?: Date;
    id?: string | undefined;
}

export enum OgcGeometryType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12,
    _13 = 13,
    _14 = 14,
    _15 = 15,
    _16 = 16,
}

export enum Ordinates {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _7 = 7,
    _8 = 8,
    _16 = 16,
    _32 = 32,
    _64 = 64,
    _128 = 128,
    _256 = 256,
    _512 = 512,
    _1024 = 1024,
    _2048 = 2048,
    _4096 = 4096,
    _8192 = 8192,
    _16384 = 16384,
    _32768 = 32768,
    _65535 = 65535,
    _65536 = 65536,
    _65539 = 65539,
    _65543 = 65543,
    _131072 = 131072,
    _262144 = 262144,
    _524288 = 524288,
    _1048576 = 1048576,
    _2097152 = 2097152,
    _4194304 = 4194304,
    _8388608 = 8388608,
    _16777216 = 16777216,
    _33554432 = 33554432,
    _67108864 = 67108864,
    _134217728 = 134217728,
    _268435456 = 268435456,
    _536870912 = 536870912,
    _1073741824 = 1073741824,
    __2147483648 = -2147483648,
    __65536 = -65536,
    __1 = -1,
}

export class Pharmacy implements IPharmacy {
    id?: string;
    name?: string | undefined;
    cityCode?: number;
    countyCode?: number;
    neighborhoodCode?: number;
    categoryId?: string;
    address?: string | undefined;
    fullAddress?: string | undefined;
    phone?: string | undefined;
    lat?: number;
    lon?: number;
    city?: City;
    county?: County;
    neighborhood?: Neighborhood;
    category?: Category;
    placeAssets?: PlaceAsset[] | undefined;
    note?: string | undefined;

    constructor(data?: IPharmacy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.cityCode = _data["cityCode"];
            this.countyCode = _data["countyCode"];
            this.neighborhoodCode = _data["neighborhoodCode"];
            this.categoryId = _data["categoryId"];
            this.address = _data["address"];
            this.fullAddress = _data["fullAddress"];
            this.phone = _data["phone"];
            this.lat = _data["lat"];
            this.lon = _data["lon"];
            this.city = _data["city"] ? City.fromJS(_data["city"]) : <any>undefined;
            this.county = _data["county"] ? County.fromJS(_data["county"]) : <any>undefined;
            this.neighborhood = _data["neighborhood"] ? Neighborhood.fromJS(_data["neighborhood"]) : <any>undefined;
            this.category = _data["category"] ? Category.fromJS(_data["category"]) : <any>undefined;
            if (Array.isArray(_data["placeAssets"])) {
                this.placeAssets = [] as any;
                for (let item of _data["placeAssets"])
                    this.placeAssets!.push(PlaceAsset.fromJS(item));
            }
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): Pharmacy {
        data = typeof data === 'object' ? data : {};
        let result = new Pharmacy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["cityCode"] = this.cityCode;
        data["countyCode"] = this.countyCode;
        data["neighborhoodCode"] = this.neighborhoodCode;
        data["categoryId"] = this.categoryId;
        data["address"] = this.address;
        data["fullAddress"] = this.fullAddress;
        data["phone"] = this.phone;
        data["lat"] = this.lat;
        data["lon"] = this.lon;
        data["city"] = this.city ? this.city.toJSON() : <any>undefined;
        data["county"] = this.county ? this.county.toJSON() : <any>undefined;
        data["neighborhood"] = this.neighborhood ? this.neighborhood.toJSON() : <any>undefined;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        if (Array.isArray(this.placeAssets)) {
            data["placeAssets"] = [];
            for (let item of this.placeAssets)
                data["placeAssets"].push(item.toJSON());
        }
        data["note"] = this.note;
        return data;
    }
}

export interface IPharmacy {
    id?: string;
    name?: string | undefined;
    cityCode?: number;
    countyCode?: number;
    neighborhoodCode?: number;
    categoryId?: string;
    address?: string | undefined;
    fullAddress?: string | undefined;
    phone?: string | undefined;
    lat?: number;
    lon?: number;
    city?: City;
    county?: County;
    neighborhood?: Neighborhood;
    category?: Category;
    placeAssets?: PlaceAsset[] | undefined;
    note?: string | undefined;
}

export class PharmacyListBaseResponse implements IPharmacyListBaseResponse {
    data?: Pharmacy[] | undefined;

    constructor(data?: IPharmacyListBaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Pharmacy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PharmacyListBaseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PharmacyListBaseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPharmacyListBaseResponse {
    data?: Pharmacy[] | undefined;
}

export class Place implements IPlace {
    id?: string;
    name?: string | undefined;
    cityCode?: number;
    countyCode?: number;
    neighborhoodCode?: number;
    categoryId?: string;
    address?: string | undefined;
    fullAddress?: string | undefined;
    phone?: string | undefined;
    lat?: number;
    lon?: number;
    city?: City;
    county?: County;
    neighborhood?: Neighborhood;
    category?: Category;
    placeAssets?: PlaceAsset[] | undefined;

    constructor(data?: IPlace) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.cityCode = _data["cityCode"];
            this.countyCode = _data["countyCode"];
            this.neighborhoodCode = _data["neighborhoodCode"];
            this.categoryId = _data["categoryId"];
            this.address = _data["address"];
            this.fullAddress = _data["fullAddress"];
            this.phone = _data["phone"];
            this.lat = _data["lat"];
            this.lon = _data["lon"];
            this.city = _data["city"] ? City.fromJS(_data["city"]) : <any>undefined;
            this.county = _data["county"] ? County.fromJS(_data["county"]) : <any>undefined;
            this.neighborhood = _data["neighborhood"] ? Neighborhood.fromJS(_data["neighborhood"]) : <any>undefined;
            this.category = _data["category"] ? Category.fromJS(_data["category"]) : <any>undefined;
            if (Array.isArray(_data["placeAssets"])) {
                this.placeAssets = [] as any;
                for (let item of _data["placeAssets"])
                    this.placeAssets!.push(PlaceAsset.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Place {
        data = typeof data === 'object' ? data : {};
        let result = new Place();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["cityCode"] = this.cityCode;
        data["countyCode"] = this.countyCode;
        data["neighborhoodCode"] = this.neighborhoodCode;
        data["categoryId"] = this.categoryId;
        data["address"] = this.address;
        data["fullAddress"] = this.fullAddress;
        data["phone"] = this.phone;
        data["lat"] = this.lat;
        data["lon"] = this.lon;
        data["city"] = this.city ? this.city.toJSON() : <any>undefined;
        data["county"] = this.county ? this.county.toJSON() : <any>undefined;
        data["neighborhood"] = this.neighborhood ? this.neighborhood.toJSON() : <any>undefined;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        if (Array.isArray(this.placeAssets)) {
            data["placeAssets"] = [];
            for (let item of this.placeAssets)
                data["placeAssets"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlace {
    id?: string;
    name?: string | undefined;
    cityCode?: number;
    countyCode?: number;
    neighborhoodCode?: number;
    categoryId?: string;
    address?: string | undefined;
    fullAddress?: string | undefined;
    phone?: string | undefined;
    lat?: number;
    lon?: number;
    city?: City;
    county?: County;
    neighborhood?: Neighborhood;
    category?: Category;
    placeAssets?: PlaceAsset[] | undefined;
}

export class PlaceAddRequest implements IPlaceAddRequest {
    name?: string | undefined;
    cityCode?: number;
    countyCode?: number;
    neighborhoodCode?: number;
    categoryId?: string;
    address?: string | undefined;
    phone?: string | undefined;
    lat?: number;
    lon?: number;

    constructor(data?: IPlaceAddRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.cityCode = _data["cityCode"];
            this.countyCode = _data["countyCode"];
            this.neighborhoodCode = _data["neighborhoodCode"];
            this.categoryId = _data["categoryId"];
            this.address = _data["address"];
            this.phone = _data["phone"];
            this.lat = _data["lat"];
            this.lon = _data["lon"];
        }
    }

    static fromJS(data: any): PlaceAddRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PlaceAddRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["cityCode"] = this.cityCode;
        data["countyCode"] = this.countyCode;
        data["neighborhoodCode"] = this.neighborhoodCode;
        data["categoryId"] = this.categoryId;
        data["address"] = this.address;
        data["phone"] = this.phone;
        data["lat"] = this.lat;
        data["lon"] = this.lon;
        return data;
    }
}

export interface IPlaceAddRequest {
    name?: string | undefined;
    cityCode?: number;
    countyCode?: number;
    neighborhoodCode?: number;
    categoryId?: string;
    address?: string | undefined;
    phone?: string | undefined;
    lat?: number;
    lon?: number;
}

export class PlaceAsset implements IPlaceAsset {
    id?: string;
    placeId?: string;
    photoUrl?: string | undefined;
    place?: Place;

    constructor(data?: IPlaceAsset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.placeId = _data["placeId"];
            this.photoUrl = _data["photoUrl"];
            this.place = _data["place"] ? Place.fromJS(_data["place"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PlaceAsset {
        data = typeof data === 'object' ? data : {};
        let result = new PlaceAsset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["placeId"] = this.placeId;
        data["photoUrl"] = this.photoUrl;
        data["place"] = this.place ? this.place.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPlaceAsset {
    id?: string;
    placeId?: string;
    photoUrl?: string | undefined;
    place?: Place;
}

export class PlaceBaseResponse implements IPlaceBaseResponse {
    data?: Place;

    constructor(data?: IPlaceBaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? Place.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PlaceBaseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PlaceBaseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPlaceBaseResponse {
    data?: Place;
}

export class PlacePageableResponse implements IPlacePageableResponse {
    currentPageNumber?: number;
    pageItemCount?: number;
    totalCount?: number;
    data?: Place[] | undefined;

    constructor(data?: IPlacePageableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPageNumber = _data["currentPageNumber"];
            this.pageItemCount = _data["pageItemCount"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Place.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlacePageableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PlacePageableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPageNumber"] = this.currentPageNumber;
        data["pageItemCount"] = this.pageItemCount;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlacePageableResponse {
    currentPageNumber?: number;
    pageItemCount?: number;
    totalCount?: number;
    data?: Place[] | undefined;
}

export class PlaceSearchCriteria implements IPlaceSearchCriteria {
    cityCode?: number | undefined;
    countyCode?: number | undefined;
    categoryIds?: string[] | undefined;
    name?: string | undefined;

    constructor(data?: IPlaceSearchCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cityCode = _data["cityCode"];
            this.countyCode = _data["countyCode"];
            if (Array.isArray(_data["categoryIds"])) {
                this.categoryIds = [] as any;
                for (let item of _data["categoryIds"])
                    this.categoryIds!.push(item);
            }
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PlaceSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new PlaceSearchCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cityCode"] = this.cityCode;
        data["countyCode"] = this.countyCode;
        if (Array.isArray(this.categoryIds)) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        data["name"] = this.name;
        return data;
    }
}

export interface IPlaceSearchCriteria {
    cityCode?: number | undefined;
    countyCode?: number | undefined;
    categoryIds?: string[] | undefined;
    name?: string | undefined;
}

export class PlaceSearchCriteriaPageableSearch implements IPlaceSearchCriteriaPageableSearch {
    pageNumber?: number;
    pageSize?: number;
    sortField?: string | undefined;
    sortOrder?: number | undefined;
    searchCriteria?: PlaceSearchCriteria;

    constructor(data?: IPlaceSearchCriteriaPageableSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortOrder = _data["sortOrder"];
            this.searchCriteria = _data["searchCriteria"] ? PlaceSearchCriteria.fromJS(_data["searchCriteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PlaceSearchCriteriaPageableSearch {
        data = typeof data === 'object' ? data : {};
        let result = new PlaceSearchCriteriaPageableSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortOrder"] = this.sortOrder;
        data["searchCriteria"] = this.searchCriteria ? this.searchCriteria.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPlaceSearchCriteriaPageableSearch {
    pageNumber?: number;
    pageSize?: number;
    sortField?: string | undefined;
    sortOrder?: number | undefined;
    searchCriteria?: PlaceSearchCriteria;
}

export class PlaceUpdateRequest implements IPlaceUpdateRequest {
    name?: string | undefined;
    cityCode?: number;
    countyCode?: number;
    neighborhoodCode?: number;
    categoryId?: string;
    address?: string | undefined;
    phone?: string | undefined;
    lat?: number;
    lon?: number;
    id?: string;

    constructor(data?: IPlaceUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.cityCode = _data["cityCode"];
            this.countyCode = _data["countyCode"];
            this.neighborhoodCode = _data["neighborhoodCode"];
            this.categoryId = _data["categoryId"];
            this.address = _data["address"];
            this.phone = _data["phone"];
            this.lat = _data["lat"];
            this.lon = _data["lon"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PlaceUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PlaceUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["cityCode"] = this.cityCode;
        data["countyCode"] = this.countyCode;
        data["neighborhoodCode"] = this.neighborhoodCode;
        data["categoryId"] = this.categoryId;
        data["address"] = this.address;
        data["phone"] = this.phone;
        data["lat"] = this.lat;
        data["lon"] = this.lon;
        data["id"] = this.id;
        return data;
    }
}

export interface IPlaceUpdateRequest {
    name?: string | undefined;
    cityCode?: number;
    countyCode?: number;
    neighborhoodCode?: number;
    categoryId?: string;
    address?: string | undefined;
    phone?: string | undefined;
    lat?: number;
    lon?: number;
    id?: string;
}

export class Point implements IPoint {
    factory?: GeometryFactory;
    userData?: any | undefined;
    srid?: number;
    precisionModel?: PrecisionModel;
    readonly numGeometries?: number;
    readonly isSimple?: boolean;
    readonly isValid?: boolean;
    readonly area?: number;
    readonly length?: number;
    centroid?: Point;
    interiorPoint?: Point;
    pointOnSurface?: Point;
    envelope?: Geometry;
    envelopeInternal?: Envelope;
    readonly isRectangle?: boolean;
    coordinateSequence?: CoordinateSequence;
    readonly coordinates?: Coordinate[] | undefined;
    readonly numPoints?: number;
    readonly isEmpty?: boolean;
    dimension?: Dimension;
    boundaryDimension?: Dimension;
    x?: number;
    y?: number;
    coordinate?: Coordinate;
    readonly geometryType?: string | undefined;
    ogcGeometryType?: OgcGeometryType;
    boundary?: Geometry;
    z?: number;
    m?: number;

    constructor(data?: IPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.factory = _data["factory"] ? GeometryFactory.fromJS(_data["factory"]) : <any>undefined;
            this.userData = _data["userData"];
            this.srid = _data["srid"];
            this.precisionModel = _data["precisionModel"] ? PrecisionModel.fromJS(_data["precisionModel"]) : <any>undefined;
            (<any>this).numGeometries = _data["numGeometries"];
            (<any>this).isSimple = _data["isSimple"];
            (<any>this).isValid = _data["isValid"];
            (<any>this).area = _data["area"];
            (<any>this).length = _data["length"];
            this.centroid = _data["centroid"] ? Point.fromJS(_data["centroid"]) : <any>undefined;
            this.interiorPoint = _data["interiorPoint"] ? Point.fromJS(_data["interiorPoint"]) : <any>undefined;
            this.pointOnSurface = _data["pointOnSurface"] ? Point.fromJS(_data["pointOnSurface"]) : <any>undefined;
            this.envelope = _data["envelope"] ? Geometry.fromJS(_data["envelope"]) : <any>undefined;
            this.envelopeInternal = _data["envelopeInternal"] ? Envelope.fromJS(_data["envelopeInternal"]) : <any>undefined;
            (<any>this).isRectangle = _data["isRectangle"];
            this.coordinateSequence = _data["coordinateSequence"] ? CoordinateSequence.fromJS(_data["coordinateSequence"]) : <any>undefined;
            if (Array.isArray(_data["coordinates"])) {
                (<any>this).coordinates = [] as any;
                for (let item of _data["coordinates"])
                    (<any>this).coordinates!.push(Coordinate.fromJS(item));
            }
            (<any>this).numPoints = _data["numPoints"];
            (<any>this).isEmpty = _data["isEmpty"];
            this.dimension = _data["dimension"];
            this.boundaryDimension = _data["boundaryDimension"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.coordinate = _data["coordinate"] ? Coordinate.fromJS(_data["coordinate"]) : <any>undefined;
            (<any>this).geometryType = _data["geometryType"];
            this.ogcGeometryType = _data["ogcGeometryType"];
            this.boundary = _data["boundary"] ? Geometry.fromJS(_data["boundary"]) : <any>undefined;
            this.z = _data["z"];
            this.m = _data["m"];
        }
    }

    static fromJS(data: any): Point {
        data = typeof data === 'object' ? data : {};
        let result = new Point();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["factory"] = this.factory ? this.factory.toJSON() : <any>undefined;
        data["userData"] = this.userData;
        data["srid"] = this.srid;
        data["precisionModel"] = this.precisionModel ? this.precisionModel.toJSON() : <any>undefined;
        data["numGeometries"] = this.numGeometries;
        data["isSimple"] = this.isSimple;
        data["isValid"] = this.isValid;
        data["area"] = this.area;
        data["length"] = this.length;
        data["centroid"] = this.centroid ? this.centroid.toJSON() : <any>undefined;
        data["interiorPoint"] = this.interiorPoint ? this.interiorPoint.toJSON() : <any>undefined;
        data["pointOnSurface"] = this.pointOnSurface ? this.pointOnSurface.toJSON() : <any>undefined;
        data["envelope"] = this.envelope ? this.envelope.toJSON() : <any>undefined;
        data["envelopeInternal"] = this.envelopeInternal ? this.envelopeInternal.toJSON() : <any>undefined;
        data["isRectangle"] = this.isRectangle;
        data["coordinateSequence"] = this.coordinateSequence ? this.coordinateSequence.toJSON() : <any>undefined;
        if (Array.isArray(this.coordinates)) {
            data["coordinates"] = [];
            for (let item of this.coordinates)
                data["coordinates"].push(item.toJSON());
        }
        data["numPoints"] = this.numPoints;
        data["isEmpty"] = this.isEmpty;
        data["dimension"] = this.dimension;
        data["boundaryDimension"] = this.boundaryDimension;
        data["x"] = this.x;
        data["y"] = this.y;
        data["coordinate"] = this.coordinate ? this.coordinate.toJSON() : <any>undefined;
        data["geometryType"] = this.geometryType;
        data["ogcGeometryType"] = this.ogcGeometryType;
        data["boundary"] = this.boundary ? this.boundary.toJSON() : <any>undefined;
        data["z"] = this.z;
        data["m"] = this.m;
        return data;
    }
}

export interface IPoint {
    factory?: GeometryFactory;
    userData?: any | undefined;
    srid?: number;
    precisionModel?: PrecisionModel;
    numGeometries?: number;
    isSimple?: boolean;
    isValid?: boolean;
    area?: number;
    length?: number;
    centroid?: Point;
    interiorPoint?: Point;
    pointOnSurface?: Point;
    envelope?: Geometry;
    envelopeInternal?: Envelope;
    isRectangle?: boolean;
    coordinateSequence?: CoordinateSequence;
    coordinates?: Coordinate[] | undefined;
    numPoints?: number;
    isEmpty?: boolean;
    dimension?: Dimension;
    boundaryDimension?: Dimension;
    x?: number;
    y?: number;
    coordinate?: Coordinate;
    geometryType?: string | undefined;
    ogcGeometryType?: OgcGeometryType;
    boundary?: Geometry;
    z?: number;
    m?: number;
}

export class PrecisionModel implements IPrecisionModel {
    readonly isFloating?: boolean;
    readonly maximumSignificantDigits?: number;
    scale?: number;
    precisionModelType?: PrecisionModels;

    constructor(data?: IPrecisionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).isFloating = _data["isFloating"];
            (<any>this).maximumSignificantDigits = _data["maximumSignificantDigits"];
            this.scale = _data["scale"];
            this.precisionModelType = _data["precisionModelType"];
        }
    }

    static fromJS(data: any): PrecisionModel {
        data = typeof data === 'object' ? data : {};
        let result = new PrecisionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFloating"] = this.isFloating;
        data["maximumSignificantDigits"] = this.maximumSignificantDigits;
        data["scale"] = this.scale;
        data["precisionModelType"] = this.precisionModelType;
        return data;
    }
}

export interface IPrecisionModel {
    isFloating?: boolean;
    maximumSignificantDigits?: number;
    scale?: number;
    precisionModelType?: PrecisionModels;
}

export enum PrecisionModels {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class RealmClientDto implements IRealmClientDto {
    id?: string | undefined;
    clientId?: string | undefined;

    constructor(data?: IRealmClientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): RealmClientDto {
        data = typeof data === 'object' ? data : {};
        let result = new RealmClientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        return data;
    }
}

export interface IRealmClientDto {
    id?: string | undefined;
    clientId?: string | undefined;
}

export class RealmDto implements IRealmDto {
    id?: string | undefined;
    realm?: string | undefined;
    displayName?: string | undefined;
    clients?: RealmClientDto[] | undefined;

    constructor(data?: IRealmDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.realm = _data["realm"];
            this.displayName = _data["displayName"];
            if (Array.isArray(_data["clients"])) {
                this.clients = [] as any;
                for (let item of _data["clients"])
                    this.clients!.push(RealmClientDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RealmDto {
        data = typeof data === 'object' ? data : {};
        let result = new RealmDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["realm"] = this.realm;
        data["displayName"] = this.displayName;
        if (Array.isArray(this.clients)) {
            data["clients"] = [];
            for (let item of this.clients)
                data["clients"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRealmDto {
    id?: string | undefined;
    realm?: string | undefined;
    displayName?: string | undefined;
    clients?: RealmClientDto[] | undefined;
}

export class RealmDtoListBaseResponse implements IRealmDtoListBaseResponse {
    data?: RealmDto[] | undefined;

    constructor(data?: IRealmDtoListBaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RealmDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RealmDtoListBaseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RealmDtoListBaseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRealmDtoListBaseResponse {
    data?: RealmDto[] | undefined;
}

export class Route implements IRoute {
    id?: string;
    name?: string | undefined;
    categoryId?: string;
    category?: Category;
    geometry?: Geometry;
    geoJson?: string | undefined;

    constructor(data?: IRoute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.categoryId = _data["categoryId"];
            this.category = _data["category"] ? Category.fromJS(_data["category"]) : <any>undefined;
            this.geometry = _data["geometry"] ? Geometry.fromJS(_data["geometry"]) : <any>undefined;
            this.geoJson = _data["geoJson"];
        }
    }

    static fromJS(data: any): Route {
        data = typeof data === 'object' ? data : {};
        let result = new Route();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["categoryId"] = this.categoryId;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        data["geometry"] = this.geometry ? this.geometry.toJSON() : <any>undefined;
        data["geoJson"] = this.geoJson;
        return data;
    }
}

export interface IRoute {
    id?: string;
    name?: string | undefined;
    categoryId?: string;
    category?: Category;
    geometry?: Geometry;
    geoJson?: string | undefined;
}

export class RouteAddRequest implements IRouteAddRequest {
    name?: string | undefined;
    categoryId?: string;
    geoJson?: string | undefined;

    constructor(data?: IRouteAddRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.categoryId = _data["categoryId"];
            this.geoJson = _data["geoJson"];
        }
    }

    static fromJS(data: any): RouteAddRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RouteAddRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["categoryId"] = this.categoryId;
        data["geoJson"] = this.geoJson;
        return data;
    }
}

export interface IRouteAddRequest {
    name?: string | undefined;
    categoryId?: string;
    geoJson?: string | undefined;
}

export class RouteBaseResponse implements IRouteBaseResponse {
    data?: Route;

    constructor(data?: IRouteBaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? Route.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RouteBaseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RouteBaseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRouteBaseResponse {
    data?: Route;
}

export class RouteListBaseResponse implements IRouteListBaseResponse {
    data?: Route[] | undefined;

    constructor(data?: IRouteListBaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Route.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RouteListBaseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RouteListBaseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRouteListBaseResponse {
    data?: Route[] | undefined;
}

export class TextContent implements ITextContent {
    id?: string;
    originalText?: string | undefined;
    originalLangCode?: string | undefined;
    originalLanguage?: Language;
    translations?: Translation[] | undefined;

    constructor(data?: ITextContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.originalText = _data["originalText"];
            this.originalLangCode = _data["originalLangCode"];
            this.originalLanguage = _data["originalLanguage"] ? Language.fromJS(_data["originalLanguage"]) : <any>undefined;
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations!.push(Translation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TextContent {
        data = typeof data === 'object' ? data : {};
        let result = new TextContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["originalText"] = this.originalText;
        data["originalLangCode"] = this.originalLangCode;
        data["originalLanguage"] = this.originalLanguage ? this.originalLanguage.toJSON() : <any>undefined;
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITextContent {
    id?: string;
    originalText?: string | undefined;
    originalLangCode?: string | undefined;
    originalLanguage?: Language;
    translations?: Translation[] | undefined;
}

export class Translation implements ITranslation {
    id?: string;
    textContentId?: string;
    langCode?: string | undefined;
    trans?: string | undefined;
    language?: Language;
    textContent?: TextContent;

    constructor(data?: ITranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.textContentId = _data["textContentId"];
            this.langCode = _data["langCode"];
            this.trans = _data["trans"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.textContent = _data["textContent"] ? TextContent.fromJS(_data["textContent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Translation {
        data = typeof data === 'object' ? data : {};
        let result = new Translation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["textContentId"] = this.textContentId;
        data["langCode"] = this.langCode;
        data["trans"] = this.trans;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["textContent"] = this.textContent ? this.textContent.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITranslation {
    id?: string;
    textContentId?: string;
    langCode?: string | undefined;
    trans?: string | undefined;
    language?: Language;
    textContent?: TextContent;
}

export class TranslationBaseResponse implements ITranslationBaseResponse {
    data?: Translation;

    constructor(data?: ITranslationBaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? Translation.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TranslationBaseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationBaseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITranslationBaseResponse {
    data?: Translation;
}

export class TranslationListBaseResponse implements ITranslationListBaseResponse {
    data?: Translation[] | undefined;

    constructor(data?: ITranslationListBaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Translation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TranslationListBaseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationListBaseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITranslationListBaseResponse {
    data?: Translation[] | undefined;
}

export class TranslationRequest implements ITranslationRequest {
    id?: string;
    lang?: string | undefined;
    translation?: string | undefined;

    constructor(data?: ITranslationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lang = _data["lang"];
            this.translation = _data["translation"];
        }
    }

    static fromJS(data: any): TranslationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lang"] = this.lang;
        data["translation"] = this.translation;
        return data;
    }
}

export interface ITranslationRequest {
    id?: string;
    lang?: string | undefined;
    translation?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}